svg4everybody();

const APP = {
	name: 'Национальное Агентство Развития Квалификаций by <a href="https://ibrush.ru">iBrush</a>'
};
function selectStyler() {

    var select = $('.select');

    if (select.length) {
        select.each(function(){
            if ( $(this).find('.jq-selectbox').length ) {
                $(this).find('select').trigger('refresh');
            }
            else {
                $(this).find('select').styler({
                    selectSmartPositioning : false,
                    selectSearch           : true,
                    selectSearchLimit      : 10
                });
            }
        });
    }

}
function showCode(container, collapsible) {

    var button  = container.find('._js-show-code-button'),
        showCodeBody = container.find('.show-code__body');

    container.find('.show-code').each(function(){
        if (!$(this).hasClass('_expanded')) {
            $(this).find('.show-code__body').hide();
        }
    });

    button.on('click', function(){

        var showCode = $(this).parents('.show-code'),
            showText = $(this).attr('data-show'),
            hideText = $(this).attr('data-hide');

        if ( !showCode.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.show-code').removeClass('_expanded');
                showCodeBody.stop().slideUp(300);
            }
            showCode.addClass('_expanded');
            $(this).text(hideText);
            showCode.find('.show-code__body').stop().slideDown(300);
        } else {
            showCode.removeClass('_expanded');
            $(this).text(showText);
            showCode.find('.show-code__body').stop().slideUp(300);
        }
    });
}

$(function () {

    $(document).on('click', '._js-tabs-link', function(e) {
        e.preventDefault(); // Prevent default link behavior.
        var tabID = $(this).attr('data-target'); // Pull the data-target value as the tabID.

        $(this).addClass('_active').parent().addClass('_active'); // Add the ._active class to the link and it's parent li (if one exists).
        $(this).siblings().removeClass('_active'); // Remove the ._active class from sibling tab navigation elements.
        $(this).parent('li').siblings().removeClass('_active').children().removeClass('_active'); // Remove the ._active class from sibling li elements and their links.
        $(tabID).addClass('_active'); // Add the ._active class to the div with the tab content.
        $(tabID).siblings().removeClass('_active'); // Remove the ._active class from other tab content divs.
    });

});

function inputFile() {

    $(document).on('click', '._js-file-button', function(){
        let inputFile  = $(this).parents('.input-file').find('._js-input-file');

        inputFile.trigger('click');
        inputFile.on('change', function(){
            let inputText   = $(this).parents('.input-file').find('._js-input-text');

            if ( $(this).val ) {
                let uploadedFileName = this.files[0].name;
                inputText.val(uploadedFileName);
            } else {
                inputText.val('');
            }
        });
    });
}
//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

function map(id, lat, lon) {

    if ( $('#'+id).length ) {

        // устанавливает высоту блока с картой в зависимости от контента
        if( $('.map-content').length ) {
            var contentHeight = $('.map-content').outerHeight();
            $('.map-container').height(contentHeight + 100);
        }

        ymaps.ready(function () {
            var map = new ymaps.Map(id, {
                    center: [lat, lon],
                    zoom: 9,
                    controls: []
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    `<div class="map-popup">
                        <div class="map-popup__inner">
                            <button type="button" class="map-popup__close _js-close-popup">
                            <svg class="i _close"><use xlink:href="#close"/></svg>
                            </button> $[[options.contentLayout observeSize  minWidth=235 maxWidth=235 maxHeight=350]]</div>
                    </div>`, {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('._js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('._js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2),
                                top: -(this._$element[0].offsetHeight)
                                //top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if(!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight
                                    //position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]

                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            //return element && element[0] && element.find('.arrow')[0];
                            return element && element[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonContent]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>'
                ),

                // Создание метки с пользовательским макетом балуна.
                placemark = window.placemark = new ymaps.Placemark(map.getCenter(), {
                    balloonHeader: 'г. Нижний Новгород, ул. Родионова, д.27, эт.2',
                    balloonContent: 'ООО «Центр оценки квалификации» №678675',
                    balloonPhone: '8 (875) 777-88-99',
                    balloonEmail: 'emailname@gmail.com'
                },{
                    balloonShadow: false,
                    balloonLayout: balloonLayout,
                    balloonContentLayout: balloonLayoutContent,
                    balloonPanelMaxMapArea: 0,
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/svg_icons/map-marker.svg',
                    iconImageSize: [46, 36],
                    iconImageOffset: [-23, -36]
                });

            map.geoObjects.add(placemark);

            map.controls.add('zoomControl', {
                position: {
                    right: '20px',
                    top: '108px;'
                }
            });

            // Проверка на устройство на котором открыта страница.
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            }

            if (isMobile.any()) {
                map.behaviors.disable('drag');

                //disable map scroll on mobile devices
                $(document.body).on('scroll', function() {
                    map.behaviors.disable('drag');
                });
            }

            //блокировка/разблокировка карты
            $(document).on('click',function (e) {
                var el = '.map-container';
                // console.log($(e.target), $(e.target).closest(el).length);
                if (isMobile.any()){
                    if ($(e.target).closest(el).length) {
                        map.behaviors.enable('drag');
                    } else {
                        map.behaviors.disable('drag');
                    }
                }
            });
        });
    }
}

//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

function mapRoute(id, lat, lon) {

    if ( $('#'+id).length ) {

        // устанавливает высоту блока с картой в зависимости от контента
        if( $('.map-content').length ) {
            var contentHeight = $('.map-content').outerHeight();
            $('.map-container').height(contentHeight + 100);
        }

        ymaps.ready(function () {
            var map = new ymaps.Map(id, {
                    center: [lat, lon],
                    zoom: 9,
                    controls: ['routePanelControl']
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    `<div class="map-popup">
                        <div class="map-popup__inner">
                            <button type="button" class="map-popup__close _js-close-popup">
                            <svg class="i _close"><use xlink:href="#close"/></svg>
                            </button> $[[options.contentLayout observeSize  minWidth=235 maxWidth=235 maxHeight=350]]</div>
                    </div>`, {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('._js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('._js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2),
                                top: -(this._$element[0].offsetHeight)
                                //top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if (!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight
                                    //position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]

                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            //return element && element[0] && element.find('.arrow')[0];
                            return element && element[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonContent]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>'
                ),

                // Создание метки с пользовательским макетом балуна.
                placemark = new ymaps.Placemark(map.getCenter(), {
                    balloonHeader: 'г. Нижний Новгород, ул. Родионова, д.27, эт.2',
                    balloonContent: 'ООО «Центр оценки квалификации» №678675',
                    balloonPhone: '8 (875) 777-88-99',
                    balloonEmail: 'emailname@gmail.com'
                }, {
                    balloonShadow: false,
                    balloonLayout: balloonLayout,
                    balloonContentLayout: balloonLayoutContent,
                    balloonPanelMaxMapArea: 0,
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/svg_icons/map-marker.svg',
                    iconImageSize: [46, 36],
                    iconImageOffset: [-23, -36]
                });

            var multiRoute;
            var control = map.controls.get('routePanelControl');

            control.routePanel.state.set({
                type: 'masstransit',
                fromEnabled: true,
                toEnabled: false,
            });

            placemark.events.add('balloonopen', function (e) {
                control.routePanel.state.set({
                    to: placemark.geometry.getCoordinates()
                });

                control.routePanel.options.set({
                    allowSwitch: false,
                    reverseGeocoding: true,
                    types: { masstransit: true, pedestrian: true, taxi: true }
                });

            });

            // map.geoObjects.add(multiRoute);
            map.geoObjects.add(placemark);

            map.controls.add('zoomControl', {
                position: {
                    right: '20px',
                    top: '108px;'
                }
            });

            // Проверка на устройство на котором открыта страница.
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            }

            if (isMobile.any()) {
                map.behaviors.disable('drag');

                //disable map scroll on mobile devices
                $(document.body).on('scroll', function() {
                    map.behaviors.disable('drag');
                });
            }

            //блокировка/разблокировка карты
            $(document).on('click',function (e) {
                var el = '.map-container';

                if (isMobile.any()){
                    if ($(e.target).closest(el).length) {
                        map.behaviors.enable('drag');
                    } else {
                        map.behaviors.disable('drag');
                    }
                }
            });
        });
    }
}

function modal(id) {

  if (id.length) {
    let close = true;

    if ( id.attr('data-close') ) {
      close = false
    }

    id.bPopup({
        positionStyle: 'fixed',
        easing: 'easeOutBack',
        speed: 350,
        opacity: .5,
        appending: true,
        appendTo: '.website-wrapper',
        modalColor: '#3b4256',
        modalClose: close,
        onOpen: function() {
          let windowWidth = $('.workarea').width();
          setTimeout(function(){
            $("body").addClass('_modal-opened');
            $('.website-wrapper').css('max-width', windowWidth);

            const $scrollbar = $('.js-popup-scrollbar');
            if($scrollbar.length) {
              const ps = new CustomScrollbar($scrollbar);
            }

          }, 400);
        },
        onClose: function() {
          if (id.data('reload')) {
            window.location.reload();
          }
          // две открытых модвлки
          if($('.modal:visible').length) return;

          $("body").removeClass('_modal-opened');
          $('.website-wrapper').css('max-width', '');
        }
    });
  }

}

function CustomScrollbar(cont){
  this.cont = cont;
  this.scrollBars = [];
  this.init();
}

CustomScrollbar.prototype = {
  init: function(){
    var obj = this;
    if (this.cont.length > 0) {
      this.cont.each(function(){
        obj.scrollBars.push(new PerfectScrollbar(this));
      })
    }
  },
  update: function(){
    this.scrollBars.forEach(function(el){
      el.update();
    })
  }
}

function userListElement() {

    var show = $('._js-user-list-show'),
        hide = $('._js-user-list-hide');

    //$('._js-user-list-details').hide();

    show.on('click', function(){
        var element = $(this).parents('.user-list-element'),
            details = element.find('._js-user-list-details'),
            svg =  $(this).find('._arr-rounded-corner');

        if ( !element.hasClass('_active') ) {
            element.stop().addClass('_active');
            details.stop().slideDown(300);
            svg.addClass('_arr-rounded-corner_open');
        }
    });

    hide.on('click', function(){
        var element = $(this).parents('.user-list-element'),
            details = element.find('._js-user-list-details'),
            svg =  $(this).parents('.user-list-element').find('._arr-rounded-corner');

        if ( element.hasClass('_active') ) {
            element.stop().removeClass('_active');
            details.stop().slideUp(300);
            svg.removeClass('_arr-rounded-corner_open');
        }
    });
}
function calendar() {

    let calendarStart = $('._js-calendar-start');
    let calendarEnd   = $('._js-calendar-end');

    if ( calendarStart.length ) {
        let parent = calendarStart.parents('.input');
        calendarStart
            .daterangepicker({
                "singleDatePicker": true,
                "parentEl" : parent,
                "showDropdowns" : true,
                "autoUpdateInput" : false,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "separator": " - ",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            })
            //.val('')
            .on('apply.daterangepicker', function(ev, picker) {
                let date = picker.startDate.format('DD.MM.YYYY');

                $(this).val(date).change();
                let flag = false;
                if ( calendarEnd.val() != '' ) {
                    flag = true;
                }
                calendarEnd
                    .daterangepicker({
                        'minDate' : date,
                        "singleDatePicker": true,
                        "parentEl" : parent,
                        "showDropdowns" : true,
                        "locale": {
                            "format": "DD.MM.YYYY",
                            "separator": " - ",
                            "weekLabel": "Н",
                            "daysOfWeek": [
                                "Вс",
                                "Пн",
                                "Вт",
                                "Ср",
                                "Чт",
                                "Пт",
                                "Сб"
                            ],
                            "monthNames": [
                                "Январь",
                                "Февраль",
                                "Март",
                                "Апрель",
                                "Май",
                                "Июнь",
                                "Июль",
                                "Август",
                                "Сентябрь",
                                "Октябрь",
                                "Ноябрь",
                                "Декабрь"
                            ],
                            "firstDay": 1
                        }
                    });
                    if ( !flag ) {
                        calendarEnd.val('');
                    }
            })
            .on('keydown', function(){
                if ( calendarEnd.val() === '' ) {
                    console.log('start');
                    calendarStart
                        .val('')
                }
            });
    }

    if ( calendarEnd.length ) {
        let parent = calendarEnd.parents('.input');
        calendarEnd
            .daterangepicker({
                "singleDatePicker": true,
                "parentEl" : parent,
                "showDropdowns" : true,
                "autoUpdateInput" : false,
                "locale": {
                    "format": "DD.MM.YYYY",
                    "separator": " - ",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            })
            //.val('')
            .on('apply.daterangepicker', function(ev, picker) {
                let date = picker.startDate.format('DD.MM.YYYY');

                $(this).val(date).change();
                let flag = false;
                if ( calendarStart.val() != '' ) {
                    flag = true;
                }
                calendarStart
                    .daterangepicker({
                        'maxDate' : date,
                        "singleDatePicker": true,
                        "parentEl" : parent,
                        "showDropdowns" : true,
                        "locale": {
                            "format": "DD.MM.YYYY",
                            "separator": " - ",
                            "weekLabel": "Н",
                            "daysOfWeek": [
                                "Вс",
                                "Пн",
                                "Вт",
                                "Ср",
                                "Чт",
                                "Пт",
                                "Сб"
                            ],
                            "monthNames": [
                                "Январь",
                                "Февраль",
                                "Март",
                                "Апрель",
                                "Май",
                                "Июнь",
                                "Июль",
                                "Август",
                                "Сентябрь",
                                "Октябрь",
                                "Ноябрь",
                                "Декабрь"
                            ],
                            "firstDay": 1
                        }
                    });
                    if ( !flag ) {
                        calendarStart.val('');
                    }
            })
            .on('keydown', function(){
                if ( calendarStart.val() === '' ) {
                    console.log('end');
                    calendarEnd
                        .val('')
                }
            });
    }
}
function dateRange() {

    let calendarFrom  =  $('#_js-calendar-start');
    let calendarTo    =  $('#_js-calendar-end');

    if ( calendarFrom.length && calendarTo.length ) {
        let dateFormat = "dd.mm.yyyy";
        const options = {
            defaultDate: "+1w",
            changeMonth: true,
            changeYear: true,
            numberOfMonths: 1,
            dateFormat: dateFormat,
            monthNamesShort: [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь"
            ],
            dayNamesMin: ["Вск", "Пн", "Вт", "Ср", "Чт", "Птн", "Сб"],
            firstDay: 1
        };
        let from = calendarFrom.datepicker(options)
                .on( "change", function() {
                    to.datepicker( "option", "minDate", getDate( this ) );
                }),
            to = calendarTo.datepicker(options)
                .on( "change", function() {
                    from.datepicker( "option", "maxDate", getDate( this ) );
                });

        function getDate( element ) {
            let date;
            try {
                date = $.datepicker.parseDate( dateFormat, element.value );
            } catch( error ) {
                date = null;
            }
            return date;
        }

        /*calendarFrom.datepicker({
            onSelect: function() {
                calendarFrom.change();
            }
        });
        calendarTo.datepicker({
            onSelect: function() {
                calendarFrom.change();
            }
        });*/

        $('body').on('scroll', function(){
            $('#_js-calendar-start, #_js-calendar-end').datepicker('hide').blur();
        });
        $(window).on('resize', function(){
            $('#_js-calendar-start, #_js-calendar-end').datepicker('hide').blur();
        });

    }

}
function scroll2() {
    var link = $('._js-scroll-link');

    link.on('click',function(e){
        e.preventDefault();
        $('body').scrollTo(this.hash, this.hash);
    });
}
function responseNavigation(collapse){

    $('#_navigation-dropdown .navigation__item').appendTo('#_navigation');
    var items = $('#_navigation').find('.navigation__item');
    var maxWidth = $('#_navigation').width() - $('#_navigation-dropdown').outerWidth();
    var width = 0;
    var hideFrom = 0;
    var screenWidth = $(window).width();

    items.each(function(index){
        if (width + $(this).outerWidth() > maxWidth){
            return false;
        }
        else {
            hideFrom = index;
            width += $(this).outerWidth();
        }
    });
    if (collapse) {
        $('#_navigation').removeClass('_flex');
        items.appendTo('#_navigation-dropdown__container');
        $('#_navigation-dropdown').show();
    }
    else if (hideFrom < items.length - 1) {
        items.eq(hideFrom).nextAll('.navigation__item').appendTo('#_navigation-dropdown__container');
        $('#_navigation-dropdown').show();
            if ( screenWidth <= 599 ) {
                items.appendTo('#_navigation-dropdown__container');
                $('#_navigation-dropdown').show();
            }
    }
    else {
        $('#_navigation-dropdown').hide();
    }

    $(document).on('mouseup touchend', function(e){
        if (!$('#_navigation-dropdown').is(e.target) && $('#_navigation-dropdown').has(e.target).length === 0) {
            $('#_navigation-dropdown').removeClass('_active');
            $('#_navigation-button').removeClass('_active');
        }
    });

}
function inputTel(id) {
  if (id.length) {
    id.mask('+7 (999) 999-99-99');
  }
}

function inputTelModalReg(id) {
  if (id.length) {
    id.mask('+7 (999) 999-99-99', {completed: showSmsConfirm});
  }
}

function inputPassportSeries(id) {
    if (id.length) {
        id.mask('9999');
    }
}

function inputPassportNumber(id) {
    if (id.length) {
        id.mask('999999');
    }
}
function inputDate(id) {
  $(id).inputmask('99.99.9999',
   {
      placeholder: "дд.мм.гггг",
      showMaskOnHover: false,
      // oncomplete: function() {
      //   const dateArr = this.value.split('.');
      //   const date = new Date(`${dateArr[1]}.${dateArr[0]}.${dateArr[2]}`);
      //   $(this).data('datepicker').selectDate(date)
      // }
    })
}


function inputTime(id) {
  if (id.length) {
    id.mask('99:99', {placeholder:"чч.мм"});
  }
}

function headerSearch() {

    const input     = $('._js-header-search');
    const mobOpen   = $('._js-header-search-mob-open');
    const search    = input.parents('.header-search');
    const reset     = $('._js-header-reset');
    const mControls = $('.mobile-controls');

    input.on('focusin', function(){
        openSearch();
    });

    mobOpen.on('click', function(){
        openSearch();
    });

    function openSearch() {
      if ( !search.hasClass('_focused') ) {
        search.addClass('_focused');
        mControls.addClass('_z-index');
        setTimeout(function(){
          input.focus();
        }, 350);
      }
    }

    reset.on('click', function(){
        if ( search.hasClass('_focused') ) {
            search.removeClass('_focused');
            mControls.removeClass('_z-index');
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!search.is(e.target) && search.has(e.target).length === 0) {
            search.removeClass('_focused');
            mControls.removeClass('_z-index');
        }
    });

}

function mobileAside(width) {

    const button      = $('._js-mobile-sidebar-button');
    const body        = $('body');
    const activeClass = '_aside-opened';
    const navigation  = $('.mobile-sidebar');

    button.on('click', function(){
        if ( !body.hasClass(activeClass) ) {
            body.addClass(activeClass);
            console.log('!');
        } else {
            body.removeClass(activeClass);
            console.log('!!');
        }
    });
    $(window).on('resize', function(){
        if ( $(window).width() > width ) {
            body.removeClass(activeClass);
        }
    });
    $(document).on('mouseup touchend', function(e){
        if (
            !navigation.is(e.target) && navigation.has(e.target).length === 0
            && !button.is(e.target) && button.has(e.target).length === 0
        ) {
            body.removeClass(activeClass);
        }
    });
}
function navigationSurf(width) {

    const screen            = $(window).width();
    const nav               = $('#_navigation');
    const mobileConteiner   = $('._js-mobile-nav-container');
    const desktopConteiner  = $('._js-desktop-nav-container');

    if ( screen <= width ) {
        if ( !mobileConteiner.find(nav).length ) {
            mobileConteiner.prepend(nav);
        }
    }
    else {
        if ( !desktopConteiner.find(nav).length ) {
            nav.appendTo(desktopConteiner);
        }
    }

}
function list2select(id, width, title) {
    var list = id;
    if (list.length){
        list.menutron({
            maxScreenWidth: width,
            menuTitle: title
        });
    }
}
function accordion(container, collapsible) {

    var button  = container.find('._js-accordion-button'),
        accordionBody = container.find('.accordion__body');


    button.on('click', function(){
        var accordion = $(this).parents('.accordion');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.accordion').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.accordion__body').slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.accordion__body').stop().slideUp(300);
        }
    });
}
function addInputFile() {

    let addButton = $('._js-add-input-file');
    let i         = 1;

    addButton.on('click', function(){
        let parent  = $(this).parents('._js-input-files');
        let list    = parent.find('._js-input-files-list');

        ++i;
        list.append(createInputFile(i));
    });

}

function createInputFile(id) {
    let inputFile = '<div class="input-file">' +
                        '<input class="input-file__input _js-input-file" name="file-'+id+'" type="file">' +
                        '<div class="input">' +
                            '<input class="_js-input-text" type="text" readonly="">' +
                        '</div>' +
                        '<button class="button _js-file-button" type="button">Обзор</button>' +
                    '</div>';

    return inputFile;
}
function locationSelect(id) {

    let select = $('#'+id);

    if ( select.length ) {
        select.select2({
            width: '100%',
            language: {
                noResults : function(){
                    return "Ничего не найдено";
                }
            }
        });

        $(document).on('click', '.select2', function(){
            var customScrollBar = new CustomScrollbar($('.select2-results'));
        });
    }

}
// state=clean - это состояние. когда мы выбираем пункт с левой стороны.
// state=1sideChecked - состояние когда слева что - то выбрано
// и нужно найти пару справа.

function matching() {
  var state = "clean";
  $(".js-match").on("click", function(e){
    if (!$(this).hasClass("disabled")) {
      switch (state) {
        case "clean":
          $(this).toggleClass("checked");
          if (checkConnection(this)) {
            unCheckConnected(this);
            state = "clean";
          } else {
            deactiveSiblings(this);
            activateSide("2",true);
            state = "1sideChecked";
          }
        break
        case "1sideChecked":
          $(this).toggleClass("checked");
          if (checkConnection(this)) {
            unCheckConnected(this);
            state = "1sideChecked";
          } else {
            state = "clean";
            if ($(this).data("side") == 2) {
              createConnection(this);
              deactiveSiblings(this);
            }
            activateSide("1",true);
            activateSide("2",false);
          }
        break
      }
    }
  })

  $(window).on("resize", function(){
    reWrite($(".connected[data-side='1']"))
  })

  //создание связи
  function createConnection(el){
    if (!$(el).hasClass("connected")) {
      var side1Checked = $(".js-match-cont1").find(".checked");
      side1Checked.each(function(){
        if (!$(this).hasClass("connected")) {
          $(this).addClass("connected");
          $(el).addClass("connected");
          $(el).attr("data-item", $(this).data("item"));
          $(el).data("item", $(this).data("item"));

          writeLines($(el).find(".js-control"),$(this).find(".js-control"), $(".matching"))
        }
      })
    }
  }

  //проверка на наличие связи
  function checkConnection(el) {
    if ($(el).hasClass("connected")) {
      return true
    } else
      return false
  }

  //При разрыве связи
  function unCheckConnected(el) {
    //удаляем связующие классы
    var question = $(el).data("item");
    $("[data-item="+question+"]").each(function(){
      $(this).removeClass("checked connected");
    })
    //Смотрим нет ли слева выделенных блоков без связи
    if (side1Checked()) {
      var el = side1Checked();
      deactiveSiblings(el);
    } else {
      $(".js-match-cont2").find("[data-item="+question+"]").addClass("disabled");
    }
    //убираем связь
    $(".js-match-cont2").find("[data-item="+question+"]").data("item", "");
    $(".js-match-cont2").find("[data-item="+question+"]").removeAttr("data-item");

    //убираем линию
    $("#canvas"+question).remove();
  }

  function reWrite(el) {
    var checked = {}
    //delete all canvases
    el.each(function(index){
      var question = $(this).data("item");
      $("#canvas"+question).remove();
      var side1obj = $(".connected[data-item="+question+"]").eq(0);
      var side2obj = $(".connected[data-item="+question+"]").eq(1);
      writeLines(side1obj.find(".js-control"),side2obj.find(".js-control"), $(".matching"))
    })





  }

  // При разрыве связи, смотрим нет на левой стороне
  // выделенных, не связанных блоков.
  function side1Checked(){
    var result = false;
    $(".js-match-cont1").find(".js-match.checked").each(function(){
      if (!$(this).hasClass("connected")) {
        result = this
      }
    });
    return result;
  }
  /*deactivate side siblings*/
  function deactiveSiblings(el) {
    $(el).siblings().each(function(){
      if (!$(this).hasClass("connected")) {
        $(this).addClass("disabled");
      }
    })
  }

  /*activate/deactivate side*/
  function activateSide(number,bool){
    if (bool){
      $(".js-match-cont"+number).find(".js-match").each(function(){
        $(this).removeClass("disabled");
      })
    } else {
      $(".js-match-cont"+number).find(".js-match").each(function(){
        if (!$(this).hasClass("connected")) {
          $(this).addClass("disabled");
        }
      })
    }
  }



}


//рисование линй
function writeLines(startObj, endObj, maincont){
  //получаем координаты
  var coords = getCoordinates(startObj, endObj, maincont);
  var start = coords.start;
  var end = coords.end;
  //создаем и добавляем канвас
  var canvas = createCanvas(startObj, maincont);
  //рисуем линию
  write(start,end,canvas);

  function createCanvas(startObj) {
    var id = "canvas"+ startObj.parents(".js-match").data("item");
    var canvasWidth = maincont.width();
    var canvasWidth = maincont[0].scrollWidth;
    var canvasHeight = maincont.height();
    var canvas = $("<canvas></canvas>", {
      id : id,
      class: "matching__canvas",
    })
    canvas.attr("width",canvasWidth);
    canvas.attr("height",canvasHeight);
    maincont.append(canvas);
    return $('#'+id);
  }
  function getCoordinates(startObj, endObj, maincont) {
    var coords = {
      "start": {},
      "end"  : {}
    };
    var scrolled = maincont[0].scrollLeft;
    coords.start.top = startObj.position().top + 10;
    coords.end.top = endObj.position().top + 10;
    coords.start.left = startObj.position().left + 10 + scrolled;
    coords.end.left = endObj.position().left + 10 + scrolled;

    return (coords)
  }
  function write(start,end,canvas) {
    var ctx = canvas[0].getContext('2d');
    ctx.strokeStyle = "#a3c1da";
    ctx.lineWidth = "2";
    ctx.setLineDash([5, 6]);
    ctx.moveTo(start.left,start.top);
    ctx.lineTo(end.left,end.top);
    ctx.lineCap = "round";
    ctx.stroke();
  }
}
function sortable() {
  //ставим фиксированную высоту, чтобы избежать скачков
  $(window).on('load resize', function(){
    let height = $(".js-sortable").outerHeight() + 'px';
    $(".js-sortable").css("height", height);
  });

  $(".js-sortable")
      .sortable({
          axis: "y",
          cursor: "move"
      })
      .disableSelection();

  $(".js-sortable-multiple")
      .sortable({
        cursor: "move",
        connectWith: ".js-draggable-multiple"
      })
      .disableSelection();

  $(".js-sortable-images")
      .sortable({
        tolerance : "pointer",
        cursor: "move"
      })
      .disableSelection();
}

function stateWebsites() {

    let body            = $('body');
    let webstites       = $('._js-state-websites-wrapper');
    let websitesLink    = $('._js-state-websites-link');
    let websitesClose   = $('._js-state-websites-close');
    let activeClass     = '_state-websites-opened';
    let bodyWith;

    $(window).on('load resize', function(){
        bodyWith = body.width();
    });

    websitesLink.on('click', function(e){
        e.preventDefault();

        if ( !body.hasClass(activeClass) ) {
            body.addClass(activeClass);
            body.css({
                'max-width' : bodyWith + 'px'
            });
        }
        else {
            body.removeClass(activeClass).removeAttr('style');
        }

    });

    websitesClose.on('click', function(e){
        e.preventDefault();
        if ( body.hasClass(activeClass) ) {
            body.removeClass(activeClass).removeAttr('style');
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (
            !webstites.is(e.target) && webstites.has(e.target).length === 0
                &&
            !websitesLink.is(e.target) && websitesLink.has(e.target).length === 0
        )
        {
            body.removeClass(activeClass).removeAttr('style');
        }
    });

}
function stateWebsitesNav(width) {

    let link        = $('._js-state-website-link');
    let linkBack    = $('._js-state-website-link-back');
    let content     = $('._js-state-website-content');

    link.on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-link');

        link.removeClass('_active');
        content.removeClass('_visible');
        if ( !$(this).hasClass('_active') ) {
            $(this).addClass('_active');
            $("[data-content='" + id + "']").addClass('_visible');
        }

    });

    linkBack.on('click', function(){
        $(this).parents('._js-state-website-content').removeClass('_visible');
    });

    $(window).on('load resize', function(){
        let screen = $(window).width();

        if ( screen <= width ) {
            link.removeClass('_active');
            content.removeClass('_visible');
        }
        else {
            $('._js-state-website-link:first-child').addClass('_active');
            $('._js-state-website-content:first-child').addClass('_visible');
        }
    });
}
function sliderTabs() {

    const tabs = $('._js-tabs-slider');
    let initialSlide = window.currentPage || 0;

    if ( tabs.length ) {
        tabs
            .slick({
                rows            : 0,
                draggable       : false,
                variableWidth   : true,
                slidesToScroll  : 1,
                arrows          : false,
                dots            : false,
                infinite        : false,
                initialSlide    : initialSlide
            })
            .on('click', '.slick-slide', function(){
                $('.slick-slide').removeClass('_current');
                $(this).addClass('_current');
            });
    }


}
let adUserId = $('#USER_ID');
let adSurname = $('.address-surname');
let adName = $('.address-name');
let adPatronymic = $('.address-patronymic');
let adBirthday = $('.address-birthday');
let adEmail = $('.address-email');
let adPhone = $('.address-phone');
let adCity = $('.address-city');
let adStreet = $('.address-street');
let adHouse = $('.address-house');
let adBuilding = $('.address-building');
let adRoom = $('.address-room');

$(document).on('click', '#h-table tr', function () {
    let tableTr = $(this)[0];
    
    adUserId.val(tableTr.dataset.id);
    adSurname.val(tableTr.dataset.surname);
    adName.val(tableTr.dataset.name);
    adPatronymic.val(tableTr.dataset.patronymic);
    adBirthday.val(tableTr.dataset.birthday);
    adEmail.val(tableTr.dataset.email);
    adPhone.val(tableTr.dataset.phone);
    adCity.val(tableTr.dataset.city);
    adStreet.val(tableTr.dataset.street);
    adHouse.val(tableTr.dataset.house);
    adBuilding.val(tableTr.dataset.building);
    adRoom.val(tableTr.dataset.room);

    $('#search-result').hide();
});
$(".checkAll").change(function () {

    if ($('.tabs-list').length) {
        var checkboxAll = $(this).parents('.tabs-pane._active').find('.styled-table').find('input:checkbox');
    } else {
        var checkboxAll = $(this).parents('.styled-table').find('input:checkbox');
    }

    checkboxAll.prop('checked', $(this).prop("checked"));
});
let accordionButton = $('.js-mob-accordion');

accordionButton.on('click', function () {
    let block = $(this).parents('.mobile-menu-bottom-block');

    if (!block.hasClass('_expanded')) {
        block.addClass('_expanded');
        block.find('.mobile-menu-bottom-block__body').slideDown(300);
    } else {
        block.removeClass('_expanded');
        block.find('.mobile-menu-bottom-block__body').stop().slideUp(300);
    }
});
function datePick() {

    let calendar  = $('._js-input-date');

    const dateFormat = "dd.mm.yyyy";
    const options = {
        defaultDate: "+1w",
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1,
        dateFormat: dateFormat,
        monthNamesShort: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь"
        ],
        dayNamesMin: ["Вск", "Пн", "Вт", "Ср", "Чт", "Птн", "Сб"],
        firstDay: 1,
        onSelect(formattedDate, date, inst) {
            inst.$el.val(formattedDate);
            inst.$el.trigger('change');
        }
    };

    if ( calendar.length) {
        calendar.datepicker(options)
            .on( "change", function() {
              // calendar.data('datepicker').selectDate(this.value)
            });

        /*$('body').on('scroll', function(){
            $('._js-input-date').datepicker('hide').blur();
        });

        $(window).on('resize', function(){
            $('._js-input-date').datepicker('hide').blur();
        });*/

    }

    let birthCalendar = $('._js-input-birth-date');
    if (birthCalendar.length) {
        options.yearRange = "1920:+00";
        options.defaultDate = "-20y";
        birthCalendar.datepicker(options)
            .on( "change", function() {
                // birthCalendar.datepicker( "option" );
            });

        $('body').on('scroll', function(){
            $('._js-input-birth-date').datepicker('hide').blur();
        });

        $(window).on('resize', function(){
            $('._js-input-birth-date').datepicker('hide').blur();
        });
    }
}

function scrollIt() {
  const scrollElems = document.querySelectorAll('.js-scroll-it');
  let clientX = 0;
  let clientY = 0;

  scrollElems.forEach(function(item) {
    const parent = item.closest('.js-scroll-it-container');

    const hideScrollElem = function() {
      item.classList.add('hide');

      setTimeout(function() {
        item.classList.add('stop-animation');
      }, 300);
    };

    parent.addEventListener('touchmove', function(e) {
      hideScrollElem();
    }, false);
  });
};

/* var options = {
    now: "0:00",
    twentyFour: true,
} */



if ($('.timepicker').length) {
    $('.timepicker').wickedpicker({
        now: "0:00",
        twentyFour: true,
    });

    let closeTimePicker = $('.wickedpicker__close');
    let dobTime = $('.dob-time-user');
    let btnAll = $('.js-add-time-all');
    let tableAddedTime = $('.added-time');
    let startValAll = btnAll[0].value;
    let startValDob = startValAll;


    dobTime.on('click', function () {
        $(this).addClass('active');

        closeTimePicker.on('click', function () {
            let activeTimeBtn = $('.dob-time-user.active');
            let activeTimeBtnVal = activeTimeBtn.val();

            if (dobTime.hasClass('active')) {

                if (startValDob != activeTimeBtnVal) {
                    let thisAddTimeParent = activeTimeBtn.parents('tr');
                    let thisAddTime = thisAddTimeParent.find('.added-time')[0];

                    thisAddTime.innerHTML = activeTimeBtnVal;
                    activeTimeBtn.removeClass('active');
                }
            }
        })
    });




    btnAll.on('click', function () {
        $(this).addClass('all-btn');

        closeTimePicker.on('click', function () {

            if (btnAll.hasClass('all-btn')) {
                let cureentVal = btnAll[0].value;

                if (startValAll != cureentVal) {

                    for (let i = 0; i < tableAddedTime.length; i++) {
                        tableAddedTime[i].innerHTML = cureentVal;
                    }

                    btnAll.removeClass('all-btn');
                };
            }
        })
    });

}
if($('.trng-prog-you').length){
    let btn = $('.js-full-trng');
    let trngContainer = $('.trng-prog-you__blocks');

    btn.on('click', function () {
        
        if(trngContainer.hasClass('_open')){
            trngContainer.removeClass('_open');
            btn.text('Посмотреть полный список программ');
        }else{
            trngContainer.addClass('_open');
            btn.text('Свернуть полный список программ');
        }
    });
}
let table = $('.add-in-group');
let mass = [];
let popup = $('._add-in-group');

if (table.length) {

    $('.addEmployerGroup').click(function () {
        teste();
    })

}


function teste() {
    let allCheckedChecbox = table.find('input:checked');
    mass = [];

    //console.log(allCheckedChecbox);

    if (allCheckedChecbox.length) {
        allCheckedChecbox.each(function (index, element) {
            let employesNames = $(element).parents('td._align-l').siblings('.td_widt-svg').find('.styled-table__td-name').text();
            mass.push(employesNames);
        })

        let nameInTag = mass.map( name => '<p class="textarea-names__p">' + name + '</p>').join('');
        popup.find('.textarea-names').html(nameInTag);
    };
}
function accordionAny(container, collapsible) {

    var button  = container.find('._js-accordion-button'),
        accordionBody = container.find('.js-accordion__body');


    button.on('click', function(){
        var accordion = $(this).parents('.js-accordion');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.js-accordion').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.js-accordion__body').slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.js-accordion__body').stop().slideUp(300);
        }
    });
}
function accordionBlockWithDoc(container, collapsible) {

    var button  = container.find('._js-block-with-doc-btn'),
        accordionBody = container.find('.block-with-doc__body');


    button.on('click', function(){
        var accordion = $(this).parents('.js-accordion-with-doc');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.js-accordion-with-doc').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.block-with-doc__body').slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.block-with-doc__body').stop().slideUp(300);
        }
    });
}
$(document).ready(function(){
    let btnGenerate = $('.practice-report__gener-doc');
    let allCheckbox = $('.uploaded-doc').find('.control__input');

    $('.control__input').on('click', function () {
        var somethingChecked = false;
        $(allCheckbox).each(function () {
            if ($(this).is(':checked')) {
                somethingChecked = true;
                btnGenerate.addClass('is-visible');
            }
        });

        if (!somethingChecked) {
            btnGenerate.removeClass('is-visible');
        }
    })
})

$(document).on('click', '.js-payment', function (event) {
    event.preventDefault();
    BX.showWait();
    BX.ajax({
        url: '/local/ajax/generatePayment.php',
        method: 'POST',
        data: {
            mcok: $(this).data('mcok'),
            pk: $(this).data('pk'),
            u: $(this).data('u'),
            practice: $(this).data('practice') ? 1 : 0,
        },
        dataType: 'json',
        onsuccess: function(result) {
            BX.closeWait();
            if (result.error) {
                alert(result.error);
            } else {
                window.location.href = result.filePath;
            }
        }
    });
})

$(document).ready(function () {
    let modal = $('.gen-doc');
    let modalData = modal.find('.gen-doc__attach-docs');
    let checkboxes = $('.practice-report__documents').find('.control__input');

    let arrNames = [];
    let arrDates = [];

    function getCheckedCheckbox() {
        $(checkboxes).each(function (indx) {

            if ($(this).is(':checked')) {
                let names = $(this).parents('.uploaded-doc').find('.uploaded-doc__val._name').text();
                let dates = $(this).parents('.uploaded-doc').find('.uploaded-doc__val._date').text();
                
                //записываем данные выбранных блоков в массивы
                    arrNames.push(names);
                    arrDates.push(dates);
            }
        });
    };

    function genHtml(arrNames, arrDates) {

        for (let i = 0, y = 0; i < arrNames.length, y < arrDates.length; i++ , y++) {

            let structure = `<div class="gen-doc__attach-doc">
            <div class="control">
                <label class="control__label">
                    <input type="checkbox" class="control__input">
                        <span class="control__container">
                            <span class="control__checkbox"></span>
                        </span>
                </label>
            </div>
                <ul class="gen-doc__list">
                    <li class="gen-doc__item _rep">
                        <span class="gen-doc__rep">Отчет по практике</span>
                    </li>
                    <li class="gen-doc__item">
                        <span class="gen-doc__sv">Дата редактирования:</span>
                        <span>${arrDates[y]}</span>
                    </li>
                    <li class="gen-doc__item">
                        <span class="gen-doc__sv">Автор редактирования:</span>
                        <span>${arrNames[i]}</span>
                    </li>
                </ul>
            </div>`
            modalData.append(structure);
        }
    };


    $('.practice-report__gener-doc').on('click', function () {
        getCheckedCheckbox();
        genHtml(arrNames, arrDates);
    })
})
$(function () {
    $('._js-radio-link').on('click', function () {
        var tabID = $(this).attr('data-target');
        $(this).siblings().removeClass('_active'); // Remove the ._active class from sibling tab navigation elements.
        $(tabID).addClass('_active'); // Add the ._active class to the div with the tab content.
        $(tabID).siblings().removeClass('_active'); // Remove the ._active class from other tab content divs.
    });
});
function showSmsConfirm() {
    if ($('.modal-reg-employer-inn-block').length) {
      let modal = document.querySelector('._reg-employer');
      let hiddenBlock = modal.querySelector('.tabs-pane._active').querySelector('.modal-reg-employer-inn-block');
      //let telInput = modal.querySelector('._js-input-tel-reg');

      hiddenBlock.classList.add('_open');
      hiddenBlock.querySelector('._js-sms-confirm').value = '';
      sendSms(this);
      //telInput.classList.add('_valid');
    }
}

function sendSms($phoneInput) {
    let time = 30;

    $.ajax({
        url: '/local/ajax/confirmPhone.php',
        method: 'POST',
        data: {
            action: 'sendSms',
            phone: $phoneInput.val()
        }
    });
    let $againSendButton = $phoneInput.closest('form').find('.modal-reg-employer-inn-block__btn');
    let $timerBlock = $phoneInput.closest('form').find('.modal-reg-employer-inn-block__count');

    $againSendButton.prop('disabled', true);
    setTimeout(function () {
        $againSendButton.prop('disabled', false);
    }, time * 1000);


    let timer = setInterval(function () {
        time--;
        if (time >= 0) {
            $timerBlock.html(time);
        } else {
            clearInterval(timer);
        }
    }, 1000);
}

function inputSmsCofirm(id) {
  if (id.length) {
      id.mask('9999', {completed: checkSmsConfirm});
  }
}

function checkSmsConfirm() {
    let $form = this.closest('form');
    $.ajax({
        url: '/local/ajax/confirmPhone.php',
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'checkCode',
            code: this.val(),
            phone: $form.find('._js-input-tel-reg').val()
        }
    }).done(response => {
        if (response.success) {
            $form.find('.confirm-phone-flag').val('Y');
            $form.find('._js-input-tel-reg').addClass('_valid').prop('readonly', true);
            $form.find('.modal-reg-employer-inn-block').removeClass('_open');
            $form.find('._js-input-tel-reg')[0].dispatchEvent(new Event('keyup'));
        } else {
            $form.find('._js-sms-confirm').closest('.input').addClass('_error');
        }
    });
}

function sendSmsButton() {
    $(document).on('click', '.modal-reg-employer-inn-block__btn', function (e) {
        e.preventDefault();
        sendSms($(this).closest('form').find('._js-input-tel-reg'));
    })
}

$(function() {
	console.log(APP.name);

    showCode($('._js-ui-codes'), false);
    selectStyler();
    inputFile();
    map('_js-map', 55.751574, 37.573856);
    map('_js-qualification-centers-map', 55.751574, 37.573856);
    userListElement();
    //calendar();
    initCookiePopup();
    dateRange();
    datePick();
    scroll2();
    inputTel($('._js-input-tel'));
    inputPassportSeries($('._js-input-passport-series'));
    inputPassportNumber($('._js-input-passport-number'));
    inputTelModalReg($('._js-input-tel-reg'));
    inputDate($('._js-input-date, ._js-input-birth-date'));
    inputTime($('._js-input-time'));
    inputSmsCofirm($('._js-sms-confirm'));
    sendSmsButton();
    headerSearch();
    mobileAside(1190);
    list2select($('._js-aside-nav'), 1024, 'Выберите пункт меню');
    accordion($('._js-faq-accordion'), false); //true - stands for that all other accordions will collapse
    accordion($('._js-aside-accordion'), false);
    accordion($('._js-docs-accordion'), false);
    accordion($('._js-qualifications-list'), false);
    accordionAny($('._js-pers-file-v2-accordion'), false);
    accordionBlockWithDoc($('._js-block-with-doc-accordion'), false);
    //common accordions
    accordion($('._js-acc-collapsible'), true);
    accordion($('._js-acc-non-collapsible'), false);
    addInputFile();
    locationSelect('_location-select');
    matching();
    sortable();
    stateWebsites();
    stateWebsitesNav(1190);
    sliderTabs();
    scrollIt();
    multiselect();
    initStats();

    /*создает кастомные скроллбары в указанных контейнерах*/
    if ( $('.scrollable-block').length ) {
        let scrollbars = new CustomScrollbar($('.scrollable-block'));
    }

    //  связывает чекбоксы в модалке с реальными в форме
    $(document).on('change', '.js-video-qual', function() {
      $(`.js-checkbox-list input[value=${this.value}]`)[0].checked = this.checked;
    });

    $('#_navigation').on('click', '#_navigation-button', function () {
        $('#_navigation-dropdown').toggleClass('_active');
        $('#_navigation-button').toggleClass('_active');
    });

    //disable links
    $('.isDisabled').on('click', function(e){
      e.preventDefault();
    });

    //modals
    $('.js-modal-link').on('click', function(e){
      if ($(this).attr('href')) {
        e.preventDefault();
      }
      var target = $('[data-modal='+ $(this).data('target') +']');
      modal(target);
    });

    //radio modal
    $('.js-modal-control').on('change', function(){
      if (this.checked) {
        var target = $('[data-modal='+ $(this).data('target') +']');
        modal(target);
      }
    });

    $(document).on('click', '.js-link-print-block', function(e) {
        e.preventDefault();

        printDiv('.js-print-block');
    });

    // $.fn.datepicker.language['ru'] =  {
    //     days: ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
    //     daysShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
    //     daysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
    //     months: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
    //     monthsShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
    //     today: 'Сегодня',
    //     clear: 'Очистить',
    //     dateFormat: 'dd.mm.yyyy',
    //     timeFormat: 'hh:ii',
    //     firstDay: 1
    // };

    $('.js-calendar').datepicker( $.datepicker.regional[ 'ru' ] );
    // $.datepicker.setDefaults($.datepicker.regional['ru']);

    function printDiv(divName) {
        var printContents = document.querySelector(divName).innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;

        if ($('.js-reload').length) {
            $('.js-reload').click();
        }
    }
});

$(window).on('load resize', function(){
    responseNavigation();
    navigationSurf(1190);

}).trigger('resize');


$(function() {
    if (!$('.js-schedule-datepicker').length) return;


    // Месяцы для вывода в ячейках
    const monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];

    // для добавления класса выбраной ячейки
    let currentSelectedDate = null;

    // для показа формы
    let dateChoosen = false;

    //функция в компоненте
    window.getExams().then((resp) => {
        $('.js-schedule-datepicker').datepicker({
            inline: true,
            language: 'ru',
            changeYear: false,
            minDate: new Date(),
            selectOtherMonths: true,
            showOtherMonths: true,
            prevHtml: `<svg viewbox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 28.125C7.751 28.125 1.875 22.249 1.875 15S7.751 1.875 15 1.875 28.125 7.751 28.125 15 22.249 28.125 15 28.125z"/><path d="M17.147 6.844l-7.5 7.5a.937.937 0 000 1.322l7.5 7.5 1.322-1.332L11.634 15l6.835-6.834-1.322-1.322z"/></svg>`,
            nextHtml: `<svg viewbox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm0-28.125c7.249 0 13.125 5.876 13.125 13.125S22.249 28.125 15 28.125 1.875 22.249 1.875 15 7.751 1.875 15 1.875z"/><path d="M12.853 23.156l7.5-7.5a.937.937 0 000-1.322l-7.5-7.5-1.322 1.332L18.366 15l-6.835 6.834 1.322 1.322z"/></svg>`,
            navTitles: {
                days: 'MM yyyy',
            },
            onSelect: function(formattedDate, date, inst) {
            },

            // Рендер кастомных ячеек
            onRenderCell: function (date, cellType) {
                if (cellType === 'day') {
                    const month = monthNames[date.getMonth()];
                    // Находим экзамен по текущему значению даты ячейки
                    const exam = resp.find((item) => date.toDateString() === (new Date(item.date)).toDateString());

                    if (exam && exam.time && exam.time.length) {
                        return {
                            html: `<div class="datepicker__date">
                                <div class="exam-choice">
                                    <span class="exam-choice__label js-open-dropdown">
                                        <span>${ date.getDate() } <span class="_tablet-hidden">${ month } </span></span>
                                        <svg viewbox="0 0 30 30" class="exam-choice__icon">
                                            <path d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm0-28.125c7.249 0 13.125 5.876 13.125 13.125S22.249 28.125 15 28.125 1.875 22.249 1.875 15 7.751 1.875 15 1.875z"/><path d="M12.853 23.156l7.5-7.5a.937.937 0 000-1.322l-7.5-7.5-1.322 1.332L18.366 15l-6.835 6.834 1.322 1.322z"/>
                                        </svg>
                                    </span>

                                    <div class="exam-choice__dropdown">
                                        <div class="exam-choice-list">
                                            ${ exam.time && exam.time.map((item, iindex) => (`<div class="exam-choice-list__item">
                                            <button class="exam-choice-list__label js-choose-time" data-id="${exam.id}" data-comp="${exam.comps[iindex]}" data-date="${exam.date}" data-time="${item}">${item}</button>
                                            </div>`)).join('') }
                                        </div>
                                    </div>
                                </div>
                            </div>`,
                            classes: getExtraClasses(date),
                        }
                    }

                    return {
                        html: `<div class="datepicker__date ">${ date.getDate() } <span class="_tablet-hidden">${ month }</span></div>`,
                        disabled: true
                    }
                }
            },
        });

        function getExtraClasses(date) {
            if(currentSelectedDate && currentSelectedDate.getDate() === date.getDate() && currentSelectedDate.getMonth() === date.getMonth()) {
              return '_selected _with-exam'
          } else {
            return '_with-exam'
          }
        }

        document.addEventListener('click', function(ev) {
          const target = ev.target.closest('.js-choose-time');
          if(!target) return;

          const $form = $('.js-exam-form');

          // show form

          if(!dateChoosen) {
            $form.removeClass('_hidden');
            dateChoosen = true;
          }

          const monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
          ];

          const date = new Date(target.dataset.date);
          let time = target.dataset.time;
          $("#comp").val(target.dataset.comp);
          date.setHours(parseInt(time));
          date.setMinutes(parseInt(time.slice(-2)));

          $("#time").val(date.toLocaleString());

          // для вычисления выбранной ячейки
          currentSelectedDate = date;

          $form.find('.js-date-text').html(`
            ${date.getDate()}&nbsp;${monthNames[date.getMonth()]} в&nbsp;<span class="exam-form__time">${time}</span>
          `);

          $form.find('.js-date-input').val(date);


          const scheduleDatepicker = $('.js-schedule-datepicker').datepicker().data('datepicker');
          scheduleDatepicker.clear();
        });
    });

    // click outside
    $('body').on('click', function(ev) {
      if(!ev.target.closest('.datepicker--cell-day')) {
        var scheduleDatepicker = $('.js-schedule-datepicker').datepicker().data('datepicker');
        scheduleDatepicker.clear();
      }
    });
});

!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define("Odometer",[],e):"object"==typeof exports?exports.Odometer=e():t.Odometer=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=0)}([function(t,e,n){"use strict";var i,r,o=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t};(function(){var n,s,a,u,l,h,d,p,c,f,m,g,v,M,w,b,y,x,T,E,L,S,D,A,F,O,j,C,H,k,q,W,z=[].slice;T='<span class="odometer-value"></span>',b='<span class="odometer-ribbon"><span class="odometer-ribbon-inner">'+T+"</span></span>",h='<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">'+b+"</span></span>",c='<span class="odometer-formatting-mark"></span>',l="(,ddd).dd",f=/^\(?([^)]*)\)?(?:(.)(d+))?$/,m=30,p=2e3,a=20,g=2,d=.5,s=12,n=!1,v=1e3/m,u=1e3/a,y="transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",j=document.createElement("div").style,x=null!=j.transition||null!=j.webkitTransition||null!=j.mozTransition||null!=j.oTransition,F=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,M=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,L=function(t){var e;return e=document.createElement("div"),e.innerHTML=t,e.children[0]},A=function(t,e){return t.className=t.className.replace(new RegExp("(^| )"+e.split(" ").join("|")+"( |$)","gi")," ")},E=function(t,e){return A(t,e),t.className+=" "+e},C=function(t,e){var n;if(null!=document.createEvent)return n=document.createEvent("HTMLEvents"),n.initEvent(e,!0,!0),t.dispatchEvent(n)},D=function(){var t,e;return null!=(t=null!=(e=window.performance)&&"function"==typeof e.now?e.now():void 0)?t:+new Date},O=function(t,e){return null==e&&(e=0),e?(t*=Math.pow(10,e),t+=.5,t=Math.floor(t),t/=Math.pow(10,e)):Math.round(t)},H=function(t){return t<0?Math.ceil(t):Math.floor(t)},S=function(t){return t-O(t)},q=!1,(k=function(){var t,e,n,i,r;if(!q&&null!=window.jQuery){for(q=!0,i=["html","text"],r=[],e=0,n=i.length;e<n;e++)t=i[e],r.push(function(t){var e;return e=window.jQuery.fn[t],window.jQuery.fn[t]=function(t){var n;return null==t||null==(null!=(n=this[0])?n.odometer:void 0)?e.apply(this,arguments):this[0].odometer.update(t)}}(t));return r}})(),setTimeout(k,0),w=function(){function t(e){var i,r,o,a,u,l,h,d,c,f=this;if(this.options=e,this.el=this.options.el,null!=this.el.odometer)return this.el.odometer;this.el.odometer=this,h=t.options;for(i in h)o=h[i],null==this.options[i]&&(this.options[i]=o);null==(a=this.options).duration&&(a.duration=p),s=this.options.numberLength||s,n=this.options.zeroFlag||n,this.MAX_VALUES=this.options.duration/v/g|0,this.resetFormat(),this.value=this.cleanValue(null!=(d=this.options.value)?d:""),this.renderInside(),this.render();try{for(c=["innerHTML","innerText","textContent"],u=0,l=c.length;u<l;u++)r=c[u],null!=this.el[r]&&function(t){Object.defineProperty(f.el,t,{get:function(){var e;return"innerHTML"===t?f.inside.outerHTML:null!=(e=f.inside.innerText)?e:f.inside.textContent},set:function(t){return f.update(t)}})}(r)}catch(t){t,this.watchForMutations()}}return t.prototype.renderInside=function(){return this.inside=document.createElement("div"),this.inside.className="odometer-inside",this.el.innerHTML="",this.el.appendChild(this.inside)},t.prototype.watchForMutations=function(){var t=this;if(null!=M)try{return null==this.observer&&(this.observer=new M(function(e){var n;return n=t.el.innerText,t.renderInside(),t.render(t.value),t.update(n)})),this.watchMutations=!0,this.startWatchingMutations()}catch(t){t}},t.prototype.startWatchingMutations=function(){if(this.watchMutations)return this.observer.observe(this.el,{childList:!0})},t.prototype.stopWatchingMutations=function(){var t;return null!=(t=this.observer)?t.disconnect():void 0},t.prototype.cleanValue=function(t){var e;return"string"==typeof t&&(t=t.replace(null!=(e=this.format.radix)?e:".","<radix>"),t=t.replace(/[.,]/g,""),t=t.replace("<radix>","."),t=parseFloat(t,10)||0),O(t,this.format.precision)},t.prototype.bindTransitionEnd=function(){var t,e,n,i,r,o,s=this;if(!this.transitionEndBound){for(this.transitionEndBound=!0,e=!1,r=y.split(" "),o=[],n=0,i=r.length;n<i;n++)t=r[n],o.push(this.el.addEventListener(t,function(){return!!e||(e=!0,setTimeout(function(){return s.render(),e=!1,C(s.el,"odometerdone")},0),!0)},!1));return o}},t.prototype.resetFormat=function(){var t,e,n,i,r,o,s,a;if(t=null!=(s=this.options.format)?s:l,t||(t="d"),!(n=f.exec(t)))throw new Error("Odometer: Unparsable digit format");return a=n.slice(1,4),o=a[0],r=a[1],e=a[2],i=(null!=e?e.length:void 0)||0,this.format={repeating:o,radix:r,precision:i}},t.prototype.render=function(t){var e,i,r,o,a,u,l,h,d,p,c,f;for(null==t&&(t=this.value),this.stopWatchingMutations(),this.resetFormat(),this.inside.innerHTML="",u=this.options.theme,e=this.el.className.split(" "),a=[],h=0,p=e.length;h<p;h++)i=e[h],i.length&&((o=/^odometer-theme-(.+)$/.exec(i))?u=o[1]:/^odometer(-|$)/.test(i)||a.push(i));a.push("odometer"),x||a.push("odometer-no-transitions"),u?a.push("odometer-theme-"+u):a.push("odometer-auto-theme"),this.el.className=a.join(" "),this.ribbons={},this.digits=[],l=!this.format.precision||!S(t)||!1,f=t.toString().split("").reverse();var m=[];if(n)for(var g=0,v=f.length;g<v;g++)m.push({num:f[g],zflag:!0});var M=[],w=[];if(f.length<s)for(var b=0;b<s-f.length;b++)M.push(n?{num:"0",zflag:!1}:"0");for(w=n?m.concat(M):f.concat(M),d=0,c=w.length;d<c;d++)r=w[d],"."===r&&(l=!0),this.addDigit(r,l);return this.startWatchingMutations()},t.prototype.update=function(t){var e,n=this;if(t=this.cleanValue(t),e=t-this.value)return A(this.el,"odometer-animating-up odometer-animating-down odometer-animating"),e>0?E(this.el,"odometer-animating-up"):E(this.el,"odometer-animating-down"),this.stopWatchingMutations(),this.animate(t),this.startWatchingMutations(),setTimeout(function(){return n.el.offsetHeight,E(n.el,"odometer-animating")},0),this.value=t},t.prototype.renderDigit=function(){return L(h)},t.prototype.insertDigit=function(t,e){return null!=e?this.inside.insertBefore(t,e):this.inside.children.length?this.inside.insertBefore(t,this.inside.children[0]):this.inside.appendChild(t)},t.prototype.addSpacer=function(t,e,n){var i;return i=L(c),i.innerHTML=t,n&&E(i,n),this.insertDigit(i,e)},t.prototype.addDigit=function(t,e){var i,r,o,s;if(null==e&&(e=!0),"-"===(n?t.num:t))return this.addSpacer(n?t.num:t,null,"odometer-negation-mark");if("."===(n?t.num:t))return this.addSpacer(null!=(s=this.format.radix)?s:".",null,"odometer-radix-mark");if(e)for(o=!1;;){if(!this.format.repeating.length){if(o)throw new Error("Bad odometer format without digits");this.resetFormat(),o=!0}if(i=this.format.repeating[this.format.repeating.length-1],this.format.repeating=this.format.repeating.substring(0,this.format.repeating.length-1),"d"===i)break;this.addSpacer(i)}return r=this.renderDigit(),r.querySelector(".odometer-value").innerHTML=t.num,n&&r.setAttribute("name","digit-"+t.zflag),this.digits.push(r),this.insertDigit(r)},t.prototype.animate=function(t){return x&&"count"!==this.options.animation?this.animateSlide(t):this.animateCount(t)},t.prototype.animateCount=function(t){var e,n,i,r,o,s=this;if(n=+t-this.value)return r=i=D(),e=this.value,(o=function(){var a,l,h;return D()-r>s.options.duration?(s.value=t,s.render(),void C(s.el,"odometerdone")):(a=D()-i,a>u&&(i=D(),h=a/s.options.duration,l=n*h,e+=l,s.render(Math.round(e))),null!=F?F(o):setTimeout(o,u))})()},t.prototype.getDigitCount=function(){var t,e,n,i,r,o;for(i=1<=arguments.length?z.call(arguments,0):[],t=r=0,o=i.length;r<o;t=++r)n=i[t],i[t]=Math.abs(n);return e=Math.max.apply(Math,i),Math.ceil(Math.log(e+1)/Math.log(10))},t.prototype.getFractionalDigitCount=function(){var t,e,n,i,r,o,s;for(r=1<=arguments.length?z.call(arguments,0):[],e=/^\-?\d*\.(\d*?)0*$/,t=o=0,s=r.length;o<s;t=++o)i=r[t],r[t]=i.toString(),n=e.exec(r[t]),r[t]=null==n?0:n[1].length;return Math.max.apply(Math,r)},t.prototype.resetDigits=function(){return this.digits=[],this.ribbons=[],this.inside.innerHTML="",this.resetFormat()},t.prototype.animateSlide=function(t){var e,n,i,r,o,a,u,l,h,p,c,f,m,g,v,M,w,b,y,x,T,L,S,D,A,F;if(v=this.value,u=this.getFractionalDigitCount(v,t),u&&(t*=Math.pow(10,u),v*=Math.pow(10,u)),i=t-v){for(this.bindTransitionEnd(),this.getDigitCount(v,t),r=[],e=0,p=b=0;0<=s?b<s:b>s;p=0<=s?++b:--b){if(M=H(v/Math.pow(10,s-p-1)),a=H(t/Math.pow(10,s-p-1)),o=a-M,Math.abs(o)>this.MAX_VALUES){for(h=[],c=o/(this.MAX_VALUES+this.MAX_VALUES*e*d),n=M;o>0&&n<a||o<0&&n>a;)h.push(Math.round(n)),n+=c;h[h.length-1]!==a&&h.push(a),e++}else h=function(){F=[];for(var t=M;M<=a?t<=a:t>=a;M<=a?t++:t--)F.push(t);return F}.apply(this);for(p=y=0,T=h.length;y<T;p=++y)l=h[p],h[p]=Math.abs(l%10);r.push(h)}for(this.resetDigits(),A=r.reverse(),p=x=0,L=A.length;x<L;p=++x)for(h=A[p],this.digits[p]||this.addDigit(" ",p>=u),null==(w=this.ribbons)[p]&&(w[p]=this.digits[p].querySelector(".odometer-ribbon-inner")),this.ribbons[p].innerHTML="",i<0&&(h=h.reverse()),f=D=0,S=h.length;D<S;f=++D)l=h[f],g=document.createElement("div"),g.className="odometer-value",g.innerHTML=l,this.ribbons[p].appendChild(g),f===h.length-1&&E(g,"odometer-last-value"),0===f&&E(g,"odometer-first-value");return M<0&&this.addDigit("-"),m=this.inside.querySelector(".odometer-radix-mark"),null!=m&&m.parent.removeChild(m),u?this.addSpacer(this.format.radix,this.digits[u-1],"odometer-radix-mark"):void 0}},t}(),w.options=null!=(W=window.odometerOptions)?W:{},w.init=function(t){w.options=t;var e,n,i,r,s,a;if(null!=document.querySelectorAll){for(n=document.querySelectorAll(w.options.selector||".odometer"),a=[],i=0,r=n.length;i<r;i++)e=n[i],a.push(e.odometer=new w(o({el:e,value:null!=(s=e.innerText)?s:e.textContent},t)));return a}},i=[],void 0!==(r=function(){return w}.apply(e,i))&&(t.exports=r)}).call(void 0)}])});
window.odometerOptions = {
    format: 'ddd',
    numberLength: 6,
    zeroFlag: true,
    duration: 100000
};
Odometer.init(odometerOptions);
$('.odometer').html('002756');


$(document).ready(function () {
    let blurTimeout = false;
    $('._js-form-fio').on('click',function () {
        $('_js-form-hidden').prop('checked', false);
        $(this).next().addClass('_isActive');
    })

    $('._js-form-input').on('change', function () {
        if ($(this).val() !== '') {
            if (/\d/g.test($(this).val())) {
                $(this).parent('._js-form-fio').addClass('_error');
                return false;
            }
            $(this).attr('data-name',$(this).val());
            $(this).parent('._js-form-fio').removeClass('_error').addClass('_success');
            $('._js-form-text').addClass('onCheck');

            if ($('._js-form-hidden').is(':checked')) {
                let newUrl = new URL($('meta[property="og:image"]').attr('content'));
                newUrl.searchParams.set('U_NAME',$('._js-form-input').val());
                $('meta[property="og:image"]').attr('content', newUrl.href);
            }
        }
    });

    $('._js-form-input').focus(function () {
        if (blurTimeout) clearTimeout(blurTimeout);
        if ($(this).attr('data-name') !== '') {
            console.log('123');
            $(this).val($(this).attr('data-name'));
            $(this).attr('data-name',$(this).val());

        } else {
            $(this).val('');
        }
    })

    // $('._js-form-input').blur(function () {
    //     blurTimeout = setTimeout(() => {
    //         if (!$('._js-form-hidden').is(':checked')) {
    //             $(this).val('');
    //             $('._js-form-label').removeClass('_isActive');
    //             $('._js-form-fio').removeClass('_success');
    //         } else {
    //             $('._js-form-label').removeClass('_isActive');
    //         }
    //     }, 1000);
    // });


    $('._js-form-label').on('click', function (event) {
        if (event.target.className === 'exam-certificate__form-link') {
            $('._js-form-label').removeClass('_isActive');
            return true;
        }
        if ($(this).children('input').is(':checked')) {
            $('._js-form-input').val($('._js-form-input').attr('data-name'));
            $('._js-form-fio').addClass('_success');
            $('._js-form-hidden').prop('checked', false);
            let newUrl = new URL($('meta[property="og:image"]').attr('content'));
            newUrl.searchParams.delete('U_NAME');
            $('meta[property="og:image"]').attr('content', newUrl.href);
        } else {
            setTimeout(function(){
                $('._js-form-hidden').prop('checked', true);
                let newUrl = new URL($('meta[property="og:image"]').attr('content'));
                newUrl.searchParams.set('U_NAME',$('._js-form-input').val());
                $('meta[property="og:image"]').attr('content', newUrl.href);
                $('._js-form-label').removeClass('_isActive');
            }, 100)
        }

    })

});

$(document).on('click', '.js-download-desktop-app', function () {
    let version = $(this).data('version');
    $.ajax({
        url: '/local/ajax/desktopAppStatistics.php',
        method: 'POST',
        data: {
            'version': version,
            'action': 'download'
        }
    });
});
function multiselect () {
  const PARENT_CLASS = 'js-multiselect';
  const SELECT_CLASS = 'js-multiselect-select';
  const SELECTED_CLASS = 'js-multiselect-selected';
  const SELECTED_ITEM_CLASS = 'js-multiselect-item';
  const SELECTED_REMOVE_CLASS = 'js-multiselect-remove';

  const selectParents = [...document.querySelectorAll(`.${PARENT_CLASS}`)];
  if (!selectParents.length) return;

  const selects = selectParents.map(parent => parent.querySelector(`.${SELECT_CLASS}`));
  const choices = {};
  // фабрика карточек выбранного
  const renderSelected = (name, value) => {
    const item = document.createElement('li');
    item.classList.add('multiselect__selected-item', SELECTED_ITEM_CLASS);
    item.dataset.value = value;
    item.innerHTML = `
      <p class="multiselect__selected-text">${name}</p>
      <button class="multiselect__selected-button ${SELECTED_REMOVE_CLASS}" type="button">
          <span class="visually-hidden">Удалить</span>
      </button>
    `;
    return item;
  };
  // синхронизация мультиселекта и списка выбранных
  const syncSelect = (choice) => {
    const select = choice.passedElement.element;
    const selected = select.closest(`.${PARENT_CLASS}`).querySelector(`.${SELECTED_CLASS}`);
    select.addEventListener('addItem', (evt) => {
      selected.prepend(renderSelected(evt.detail.label, evt.detail.value));
    });
    select.addEventListener('removeItem', (evt) => {
      const item = selected.querySelector(`.${SELECTED_ITEM_CLASS}[data-value="${evt.detail.value}"]`);
      if (!item) return;
      item.remove();
    });
    selected.addEventListener('click', (evt) => {
      if (!evt.target.matches(`.${SELECTED_REMOVE_CLASS}`)) return;
      evt.preventDefault();
      const item = evt.target.closest(`.${SELECTED_ITEM_CLASS}`);
      const value = item.dataset.value + '';
      item.remove();
      choice.removeActiveItemsByValue(value);
    });
  };
  // конфиг
  const getChoicesConfig = (select) => {
    const type = select.dataset.type;
    const maxItemCount = select.dataset.maxCount ? select.dataset.maxCount : -1;

    const choicesConfig = {
      single: {
        classNames: {
          listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: 'choices__search',
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      searchPlaceholderValue: 'Поиск места проведения экзамена',
      noResultsText: 'Совпадений не найдено',
      callbackOnInit: function () {
        this.passedElement.element.addEventListener('change', () => {
          this.itemList.element.style.color = '#3b4256';
        });
      },
    },
    multiple: {
      maxItemCount: maxItemCount,
      maxItemText: (maxItemCount) => {
        return `Максимальное количество - ${maxItemCount}`;
      },
      removeItems: true,
      removeItemButton: true,
      searchResultLimit: 100,
      noResultsText: 'Совпадений не найдено',
      noChoicesText: 'Выберите место проведения экзамена',
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list multiselect__select',
        inputCloned: `choices__search`,
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      callbackOnInit: function () {
        const choice = this;
        // модификации DOM списка
        this.dropdown.element.prepend(this.containerInner.element);
        this.input.element.placeholder = 'Поиск ';
        const choosedTitle = document.createElement('div');
        choosedTitle.classList.add('multiselect__select-title-wrap');
        let text;
        if (this.config.maxItemCount > 0) {
          text = `
            <p class="multiselect__select-title">Выбранные</p>
            <p class="multiselect__select-info">Максимальное количество — ${this.config.maxItemCount}</p>
          `;
        } else {
          text = `
            <p class="multiselect__select-title">Выбранные</p>
            <p class="multiselect__select-info"></p>
          `;
        }
        choosedTitle.innerHTML = text;
        this.containerInner.element.prepend(choosedTitle);
        const choicesTitle = document.createElement('div');
        choicesTitle.classList.add('multiselect__select-title-wrap');
        choicesTitle.innerHTML = '<p class="multiselect__select-title">Список</p>';
        this.dropdown.element.insertBefore(choicesTitle, this.choiceList.element);
        syncSelect(choice);
        // отрисовка выбранных по дефолту
        const selectedItems = this.getValue();
        if (!selectedItems.length) return;
        selectedItems.forEach(item => {
          const itemElement = renderSelected(item.label, item.value);
          const selected = this.passedElement.element.closest(`.${PARENT_CLASS}`).querySelector(`.${SELECTED_CLASS}`);
          selected.prepend(itemElement);
        });
      },
    },
  };
  return choicesConfig[type];
  };
  // init multiselects
  selects.forEach((element) => {
    const id = element.dataset.id;
    choices[id] = new Choices(element, getChoicesConfig(element));
  });
}

function objectMap(object, mapFn) {
  return Object.keys(object).reduce(function(result, key) {
    result[key] = mapFn(object[key]);
    return result;
  }, {});
}

function initStats () {
  if (!$('.js-stats').length) return;

  const POPUP_CLASS = 'js-stats-popup';
  const FORM_CLASS = 'js-stats-form';
  const SELECT_CLASS = 'js-stats-select';
  const SELECTED_PARAM_CLASS = 'js-stats-selected-param';
  const SELECTED_LIST_CLASS = 'js-stats-selected';
  const SELECTED_ITEM_CLASS = 'js-stats-selected-item';
  const SELECTED_REMOVE_CLASS = 'js-stats-selected-remove';
  const SEARCH_CLASS = 'js-stats-search';
  const PARAM_PARENT_CLASS = 'js-stats-param-parent';
  const PARAM_CLASS = 'js-stats-param';
  const PARAM_SELECTED_CLASS= 'js-stats-param-selected';
  const SET_PARAM_CLASS = 'js-stats-set-param';
  const $date = $('.js-stats-date');
  const $select = $(`.${SELECT_CLASS}`);
  const $dropdown = $('.js-stats-dropdown');
  const $tab = $('.js-stats-tab');

  // tabs
  const Tabs = class {

    constructor (tabsParent) {
      this.parentElem = tabsParent;
      this.data = this.parentElem.dataset.tabParent;
      this.buttonClass = 'js-stats-tab-button';
      this.activeClass = 'active';
      this.buttonList = this.parentElem.querySelector(`.js-stats-tab-list[data-tab-child=${this.data}]`);
      this.buttons = [...this.buttonList.querySelectorAll(`.${this.buttonClass}`)];
      this._activeIndex = this.buttons.indexOf(this.buttonList.querySelector(`.${this.buttonClass}.${this.activeClass}`));
      this.items = [...this.parentElem.querySelectorAll(`.js-stats-tab-item[data-tab-child=${this.data}]`)];
      this.handleTabClick = this.handleTabClick.bind(this);
      this.addListeners();
    }

    handleTabClick (evt) {
      evt.preventDefault();
      if (!evt.target.classList.contains(this.buttonClass) || evt.target.classList.contains(this.activeClass)) return;
      const index = this.buttons.indexOf(evt.target);
      this.buttons[this._activeIndex].classList.remove(this.activeClass);
      this.items[this._activeIndex].classList.remove(this.activeClass);
      evt.target.classList.add(this.activeClass);
      this.items[index].classList.add(this.activeClass);
      this._activeIndex = index;
    }

    addListeners () {
      this.buttonList.addEventListener('click', this.handleTabClick);
    }
  };
  $tab.each((index, element) => {
    new Tabs(element);
  });

  // datepicker
  $date.on('change', (evt) => {
    $(evt.target).trigger('blur');
  });

  // dropdown
  const Dropdown = class {
    constructor (dropdownElem) {
      this.dropdown = dropdownElem;
      this.data = this.dropdown.dataset.dropdownParent;
      this.dropdownButton = this.dropdown.querySelector(`.js-stats-dropdown-button[data-dropdown-child=${this.data}]`);
      this.activeClass = 'active';
      this.toggleDropdown = this.toggleDropdown.bind(this);
      this.resize = this.resize.bind(this);
      this.init();
    }

    show () {
      const maxHeight = this.dropdown.scrollHeight;
      this.dropdown.style.maxHeight = `${maxHeight}px`;
      this.dropdownButton.classList.add(this.activeClass);
      this.dropdown.classList.add(this.activeClass);
      this.dropdown.addEventListener('transitionend', () => {
        const transition = window.getComputedStyle(this.dropdown).transition;
        this.dropdown.style.overflow = 'visible';
        this.dropdown.style.transition = 'none';
        this.dropdown.style.maxHeight = '600px';
        this.dropdown.style.transition = transition;
      }, {
        once: true,
      });
    }

    hide () {
      const transition = window.getComputedStyle(this.dropdown).transition;
      this.dropdown.style.transition = 'none';
      requestAnimationFrame(() => {
        this.dropdown.style.maxHeight = this.dropdown.scrollHeight;
        this.dropdown.style.transition = transition;
        requestAnimationFrame(() => {
          const maxHeight = this.dropdownButton.scrollHeight;
          this.dropdown.style.overflow = 'hidden';
          this.dropdown.style.maxHeight = `${maxHeight}px`;
          this.dropdownButton.classList.remove(this.activeClass);
          this.dropdown.classList.remove(this.activeClass);
        });
      });

    }

    toggleDropdown (evt) {
      evt.preventDefault();
      if (this.dropdownButton.classList.contains(this.activeClass)) {
        this.hide();
        return;
      }
      this.show();
    }

    resize () {
      if (!this.dropdownButton.classList.contains(this.activeClass)) return;
      this.dropdown.style.maxHeight = `${this.dropdown.scrollHeight}px`;
    }

    init () {
      this.dropdown.style.maxHeight = '1000px';
      this.dropdownButton.addEventListener('click', this.toggleDropdown);
    }
  }
  $dropdown.each((index, element) => {
    new Dropdown(element);
  });

  // select
  function debounce (func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  const choices = {};
  const renderSelected = (name, value) => {
    const item = `
      <li class="stats__filter-selected-item js-stats-selected-item" data-value="${value}">
        <p class="stats__filter-selected-text">${name}</p>
        <button class="stats__filter-selecter-button js-stats-selected-remove" type="button">
            <span class="visually-hidden">Удалить</span>
        </button>
      </li>
    `;
    return item;
  };
  const inputHandler = debounce((evt) => {
    const value = evt.target.value;
    if (!value.trim() && !evt.initial) return;
    const $select = $(evt.target).closest('.choices').find(`.${SELECT_CLASS}`);
    const id = $select.data('id');
    $.ajax({
        method: "POST",
        url: "/local/ajax/statistics.php",
        data: {value: value, action: "searchPk"},
        dataType: "json",
    }).done(function (response) {
      if (!response.searchItems) return;
      const newChoices = response.searchItems.map((item) => {
        return {
          label: item.NAME,
          value: item.ID,
        };
      });
      choices[id].setChoices(newChoices, 'value', 'label', true);
    }).fail(function (error) {
      console.log(error.message);
    });
  }, 300);
  const choicesConfig = {
    singleArea: {
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: 'choices__search',
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      searchPlaceholderValue: 'Поиск места проведения экзамена',
      noResultsText: 'Совпадений не найдено',
      callbackOnInit: function () {
        $(this.passedElement.element).one('change', () => {
          $(this.itemList.element).css('color', '#3b4256');
        });
      },
    },
    singleSkill: {
      searchResultLimit: 100,
      noResultsText: 'Совпадений не найдено',
      noChoicesText: 'Выберите квалификацию',
      searchPlaceholderValue: 'Поиск квалификации',
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: 'choices__search',
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      callbackOnInit: function () {
        $(this.passedElement.element).one('change', () => {
          $(this.itemList.element).css('color', '#3b4256');
        });

        // ajax на ввод
        $(this.input.element).on('input', inputHandler);
        inputHandler({target: this.input.element, initial: true});
      },
    },
    multipleArea: {
      maxItemCount: 6,
      maxItemText: (maxItemCount) => {
        return `Максимальное количество - ${maxItemCount}`;
      },
      removeItems: true,
      removeItemButton: true,
      searchResultLimit: 100,
      noResultsText: 'Совпадений не найдено',
      noChoicesText: 'Выберите квалификацию',
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: `choices__search ${SEARCH_CLASS}`,
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      callbackOnInit: function () {
        const choice = this;

        // модификации DOM
        this.dropdown.element.prepend(this.containerInner.element);
        this.input.element.placeholder = 'Поиск квалификаций';
        const choosedTitle = document.createElement('div');
        choosedTitle.classList.add('stats__filter-select-title-wrap');
        choosedTitle.innerHTML = `
          <p class="stats__filter-select-title">Выбранные квалификации</p>
          <p class="stats__filter-select-info">Максимальное количество — ${this.config.maxItemCount}</p>
          `;
        this.containerInner.element.prepend(choosedTitle);

        const choicesTitle = document.createElement('div');
        choicesTitle.classList.add('stats__filter-select-title-wrap');
        choicesTitle.innerHTML = '<p class="stats__filter-select-title">Список квалификаций</p>';
        this.dropdown.element.insertBefore(choicesTitle, this.choiceList.element);

        // ajax на ввод
        $(this.input.element).on('input', inputHandler);
        inputHandler({target: this.input.element, initial: true});
        // синзронизация мультиселекта и списка выбранных
        const param = $(this.passedElement.element).closest(`.${SELECTED_PARAM_CLASS}`);
        const paramType = param.data('selected');
        const $selectedList = $(this.passedElement.element).closest(`.${FORM_CLASS}`).find(`.${SELECTED_LIST_CLASS}[data-selected=${paramType}]`);
        $(this.passedElement.element).on('addItem', (evt) => {
          $selectedList.prepend(renderSelected(evt.detail.label, evt.detail.value));
        });
        $(this.passedElement.element).on('removeItem', (evt) => {
          $selectedList.find(`.${SELECTED_ITEM_CLASS}[data-value="${evt.detail.value}"]`).remove();
        });
        $selectedList.on('click', `.${SELECTED_REMOVE_CLASS}`, (evt) => {
          evt.preventDefault();
          const $item = $(evt.target).closest(`.${SELECTED_ITEM_CLASS}`);
          const value = $item.data('value');
          $item.remove();
          choice.removeActiveItemsByValue(value);
        });
      },
    },
    multipleSkill: {
      maxItemCount: 6,
      maxItemText: (maxItemCount) => {
        return `Максимальное количество - ${maxItemCount}`;
      },
      removeItems: true,
      removeItemButton: true,
      searchResultLimit: 100,
      noResultsText: 'Совпадений не найдено',
      noChoicesText: 'Выберите место проведения экзамена',
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: `choices__search ${SEARCH_CLASS}`,
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      callbackOnInit: function () {
        const choice = this;
        // модификации DOM
        this.dropdown.element.prepend(this.containerInner.element);
        this.input.element.placeholder = 'Поиск места проведения экзамена';
        const choosedTitle = document.createElement('div');
        choosedTitle.classList.add('stats__filter-select-title-wrap');
        choosedTitle.innerHTML = `
          <p class="stats__filter-select-title">Выбранные места проведения экзамена</p>
          <p class="stats__filter-select-info">Максимальное количество — ${this.config.maxItemCount}</p>
          `;
        this.containerInner.element.prepend(choosedTitle);

        const choicesTitle = document.createElement('div');
        choicesTitle.classList.add('stats__filter-select-title-wrap');
        choicesTitle.innerHTML = '<p class="stats__filter-select-title">Список мест проведения экзамена</p>';
        this.dropdown.element.insertBefore(choicesTitle, this.choiceList.element);

        // ajax на ввод
        // $(this.input.element).on('input', inputHandler);

        // синзронизация мультиселекта и списка выбранных
        const param = $(this.passedElement.element).closest(`.${SELECTED_PARAM_CLASS}`);
        const paramType = param.data('selected');
        const $selectedList = $(this.passedElement.element).closest(`.${FORM_CLASS}`).find(`.${SELECTED_LIST_CLASS}[data-selected=${paramType}]`);
        $(this.passedElement.element).on('addItem', (evt) => {
          $selectedList.prepend(renderSelected(evt.detail.label, evt.detail.value));
        });
        $(this.passedElement.element).on('removeItem', (evt) => {
          $selectedList.find(`.${SELECTED_ITEM_CLASS}[data-value="${evt.detail.value}"]`).remove();
        });
        $selectedList.on('click', `.${SELECTED_REMOVE_CLASS}`, (evt) => {
          evt.preventDefault();
          const $item = $(evt.target).closest(`.${SELECTED_ITEM_CLASS}`);
          const value = $item.data('value') + '';
          $item.remove();
          choice.removeActiveItemsByValue(value);
        });
      },
    },
  };
  $select.each((index, element) => {
    const id = element.dataset.id;
    const type = element.dataset.type;
    choices[id] = new Choices(element, choicesConfig[type]);
    if (id === 'an-single-skill' || id === 'an-single-area') choices[id].disable();
  });
  // autoscroll on hover
  $select.on('change', (evt) => {
    $(evt.target).closest('.choices').find('.choices__selected-list').on('mouseover', (e) => {
      const text = $(e.currentTarget).find('.choices__selected')[0];
      text.textContent += '\u2000';
      let index = 1;
      function scroll () {
        requestAnimationFrame(() => {
          text.scroll({
            left: index,
          });
          if (index === 0) return;
          index += 1;
          scroll();
        });
      }
      scroll();
      $(e.currentTarget).one('mouseout', () => {
        index = 0;
        text.scroll({
          left: 0,
          behavior: 'smooth',
        });
      });
    });
  });

  // Popup
  const Popup = class {

    constructor (popupElem) {
      this.popupElement = popupElem;
      this.underlay = this.popupElement.querySelector('.js-stats-popup-underlay');
      this.closePopup = this.popupElement.querySelector('.js-stats-popup-close');
      this.activeClass = 'active';
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this._onEsc = this._onEsc.bind(this);
    }

    open () {
      this.popupElement.style.display = 'flex';
      requestAnimationFrame(() => {
          this.popupElement.classList.add(this.activeClass);
          this._addListeners();
          document.body.classList.add('no-scroll');
      });
    }

    close (evt) {
      evt.preventDefault();
      this.popupElement.classList.remove(this.activeClass);
      this.popupElement.addEventListener('transitionend', () => {
          this.popupElement.style.display = 'none';
          this._removeListeners();
          document.body.classList.remove('no-scroll');
      }, {
        once: true,
      });
    }

    _onEsc (evt) {
      const escKeyValues = ['Escape', 'Esc'];
      if (escKeyValues.some((code) => evt.key === code)) this.close(evt);
    }

    _addListeners () {
      this.underlay.addEventListener('click', this.close);
      this.closePopup.addEventListener('click', this.close);
      document.addEventListener('keydown', this.onEsc);
    }

    _removeListeners () {
      this.underlay.removeEventListener('click', this.close);
      this.closePopup.removeEventListener('click', this.close);
      document.removeEventListener('keydown', this.onEsc);
    }
  };

  const popupInvalid = new Popup(document.querySelector(`.${POPUP_CLASS}[data-popup=admin-stats-invalid]`));
  const popupError = new Popup(document.querySelector(`.${POPUP_CLASS}[data-popup=admin-stats-error]`));

  // validateForm
  const validateForm = (form) => {
    let isValid = true;
    const required = [...form.querySelectorAll(`.${SELECT_CLASS}[data-required=true]:not(:disabled)`)];
    if (!required.length) return isValid;
    isValid = required.every(select => {
      return select.value.trim();
    });
    if (!isValid) {
      required.forEach(select => {
        const choicesSingle = select.parentNode.querySelector('.choices__list--single');
        choicesSingle.classList.add('invalid');
        select.addEventListener('change', () => {
          choicesSingle.classList.remove('invalid');
        }, {once: true});
      });
      popupInvalid.open();
    }
    return isValid;
  };

  // reset select
  const resetSelect = (evt) => {
    const selects = [...evt.target.querySelectorAll('.js-stats-select')];
    const singleSelects = selects.filter(select => select.matches(':not([multiple])'));
    const multipleSelects = selects.filter(select => select.matches('[multiple]'));
    const selectedLists = [...multipleSelects[0].closest(`.${FORM_CLASS}`).querySelectorAll(`.${SELECTED_LIST_CLASS}`)];
    singleSelects.forEach(select => {
      choices[select.dataset.id].destroy();
      choices[select.dataset.id].init();
    });
    multipleSelects.forEach(select => {
      choices[select.dataset.id].removeActiveItems();
    })
    selectedLists.forEach(list => {
      list.innerHTML = '';
    });
  };

  // ajax
  const ajaxTemplate = (requestData) => {
      return window.fetch('/local/ajax/statistics.php', {method: 'POST', body: requestData})
          .then(function(response) {return response.json();})
  };

  // cards page
  const CARDS_PAGE_CLASS = 'js-stats-cards';
  const CARD_CLASS = 'js-stats-card';
  const CARD_COUNT_CLASS = 'js-stats-card-count';
  const cardsPageElement = document.querySelector(`.${CARDS_PAGE_CLASS}`);
  const cardsAjaxTemplate = () => {

    let data = new FormData($('.js-stats-cards .js-stats-form')[0])
    return window.fetch('/local/ajax/statistics.php', {method: 'POST', body: data})
        .then(function(response) {return response.json();})

    /*return new Promise((resolve, reject) => {
      return resolve(
        {
          request: {
            all: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
            success: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
            fail: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
          },
          theory: {
            all: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
            success: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
            fail: {
              count: Math.round(Math.random() * 100),
              href: '#',
            },
          },
        }
      );
    });*/
  };
  const CardsPage = class {
    constructor (page) {
      this.parent = page;
      this.cardCountClass = CARD_COUNT_CLASS;
      this.form = this.parent.querySelector(`.${FORM_CLASS}`);
      this.cards = [...this.parent.querySelectorAll(`.${CARD_CLASS}`)];
      this.update = this.update.bind(this);
      this._init();
      this._addListeners();
    }

    update (data) {
      this.cards.forEach(card => {
        const group = card.dataset.statsGroup;
        const type = card.dataset.statsType;
        card.href = data[group][type].href;
        card.querySelector(`.${this.cardCountClass}`).textContent = data[group][type].count;
      });
    }

    _addListeners () {
      this.form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        if (!validateForm(evt.target)) {
          return;
        };

        const data = new FormData(evt.target);

        cardsAjaxTemplate()
          .then(data => this.update(data))
          .catch(error => {
            console.log(error);
            popupError.open();
          });
      });
      this.form.addEventListener('reset', (evt) => {
        resetSelect(evt);
        cardsAjaxTemplate()
          .then(data => this.update(data))
          .catch(error => {
            console.log(error);
            popupError.open();
          });
      });
    }

    _init () {
      cardsAjaxTemplate()
        .then(data => this.update(data))
        .catch(error => {
          console.log(error);
          popupError.open();
        });
    }
  };
  const cardsPage = new CardsPage(cardsPageElement);

  // table page
  const TABLE_PAGE = 'js-stats-table'
  const TABLE_CLASS = 'js-stats-tbody';
  const POPUP_OPEN_CLASS = 'js-stats-skill';
  const POPUP_TABLE_CLASS = 'js-stats-popup-table';
  const tableAjaxTemplate = (requestData) => {

      return window.fetch('/local/ajax/statistics.php', {method: 'POST', body: requestData})
          .then(function(response) {return response.json();})
    /*return new Promise ((resolve, reject) => {
      const getItem = () => {
        return {
          correct: Math.round(Math.random() * 100) + '%',
          time: '00:' + Math.round(Math.random() * 59),
          number: Math.round(Math.random() * 200),
        };
      };
      return resolve(new Array(20).fill(null).map(item => getItem()));
    });*/
  };


  const TablePage = class {
    constructor (page) {
      this.parent = page;
      this.form = this.parent.querySelector(`.${FORM_CLASS}`);
      this.table = this.parent.querySelector(`.${TABLE_CLASS}`);
      this.buttonClass = POPUP_OPEN_CLASS;
      this.popup = new Popup(document.querySelector(`.${POPUP_CLASS}[data-popup=admin-stats-table]`));
      this.popupElement = this.popup.popupElement;
      this.popupTable = this.popupElement.querySelector(`.${POPUP_TABLE_CLASS}`);
      this.initClass = 'init';
      this._openPopup = this._openPopup.bind(this);
      this._addListeners();
    }

    update (data) {
      this.parent.classList.remove(this.initClass);
      const sumArray = (array) => array.reduce((accum, item) => {
        accum += item;
        return accum;
      }, null);
      const tableRows = data.props.reduce((accum, item) => {
        accum +=
          `<tr class="stats__skill-tr">
            <td class="stats__skill-td">
              <button class="stats__skill-button ${this.buttonClass}" data-id="${item.id}">${item.prop}</button>
            </td>
            <td class="stats__skill-td">${sumArray(item.request)}</td>
            <td class="stats__skill-td">${sumArray(item.success)}</td>
            <td class="stats__skill-td">${sumArray(item.fail)}</td>
          </tr>`
        return accum;
      }, '');
      this.table.innerHTML = tableRows;
    }

    _addListeners () {
      this.form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        if (!validateForm(evt.target)) {
          return;
        }
        const data = new FormData(evt.target);
        ajaxTemplate(data)
          .then(data => this.update(data))
          .catch(error => {
            console.log(error);
            popupError.open();
          });
      });
      this.form.addEventListener('reset', (evt) => {
        let data = new FormData(evt.target);
        resetSelect(evt);
        this.parent.classList.add(this.initClass);
        // ajaxTemplate()
        //   .then(data => this.update(data))
        //   .catch(error => {
        //     console.log(error);
        //     popupError.open();
        //   });
      });
      this.table.addEventListener('click', this._openPopup);
    }

    _openPopup (evt) {
      evt.preventDefault();
      evt.target.blur();
      if (!evt.target.matches(`.${this.buttonClass}`)) return;

      let skill = $(evt.target).data('id');
      $('[data-popup=admin-stats-table] .js-stats-popup-name').text(evt.target.textContent);

      let formData = new FormData($('.js-stats-table .js-stats-form')[0]);
      formData.append('action', 'getQuestionsStatistics');
      formData.append('id', skill);

      tableAjaxTemplate(formData).then(data => {
        const tableRows = data.reduce((accum, item, index) => {
          accum +=
            `<tr class="stats__popup-tr">
              <td class="stats__popup-td">${item.name}</td>
              <td class="stats__popup-td">${item.correct}</td>
              <td class="stats__popup-td">${item.time}</td>
              <td class="stats__popup-td">${item.number}</td>
            </tr>`
          return accum;
        }, '')

        this.popupTable.innerHTML = tableRows;
        this.popup.open();
      }).catch(error => {
        console.log(error);
        popupError.open();
      });

    }
  };
  const tablePageElement = document.querySelector(`.${TABLE_PAGE}`);
  const tablePage = new TablePage(tablePageElement);

  // analytics page
  const ANALYTICS_PAGE_CLASS = 'js-stats-analytics';
  const CHART_WRAP_CLASS = 'js-stats-chart-wrap';
  const CHART_VIEW_CLASS = 'js-stats-chart-view';
  const CHART_VIEW_INPUT_CLASS = 'js-stats-chart-view-input';
  const CHART_PARENT_CLASS = 'js-stats-chart-parent';
  const CHART_AREA_CLASS = 'js-stats-area';
  const CHART_INTERVAL_START_CLASS = 'js-stats-interval-start';
  const CHART_INTERVAL_END_CLASS = 'js-stats-interval-end';
  const CHART_NAME_CLASS = 'js-stats-name';
  const CHART_PROPS_CLASS = 'js-stats-props';
  const CHART_CLASS = 'js-stats-chart';
  const TOGGLE_CHART_CLASS = 'js-stats-chart-toggle';
  const CHART_PRINT_CLASS = 'js-stats-chart-print';
  const CHART_PRINT_TITLE_CLASS = 'js-stats-chart-print-title';
  const CHART_PRINT_TEXT_CLASS = 'js-stats-chart-print-text';
  const ADAPT_CLASS = 'js-stats-adapt';

  const MyChart = class {
    constructor (chartItem, ajaxData) {
      this.parent = chartItem;
      this.chartElement = this.parent.querySelector(`.${CHART_CLASS}`);
      this.printButton = this.parent.querySelector(`.${CHART_PRINT_CLASS}`);
      this.toggleClass = TOGGLE_CHART_CLASS;
      this.toggles = [...this.parent.querySelectorAll(`.${this.toggleClass}`)];
      this.chartType = this.parent.dataset.chartType;
      this._GRAPH_COLORS = [
        {
          name: 'blue',
          r: 80,
          g: 138,
          b: 255,
        },
        {
          name: 'yellow',
          r: 243,
          g: 168,
          b: 62,
        },
        {
          name: 'green',
          r: 49,
          g: 217,
          b: 156,
        },
        {
          name: 'red',
          r: 229,
          g: 77,
          b: 96,
        },
        {
          name: 'purple',
          r: 133,
          g: 103,
          b: 255,
        },
        {
          name: 'pink',
          r: 236,
          g: 121,
          b: 255,
        },
      ];
      this._bgColors = this._GRAPH_COLORS.map(item => {
        return `rgba(${item.r}, ${item.g}, ${item.b}, 1)`;
      })
      this.data = ajaxData;
      this.chart = new Chart(this.chartElement, this._getChartConfig());
      this.activeClass = 'active';
      this.dataURL = '';
      this.title = this.parent.querySelector(`.${CHART_PRINT_TITLE_CLASS}`);
      this._toggleChart = this._toggleChart.bind(this);
      this._addListeners();
    }

    updateView (ajaxData, view) {
      this.data = ajaxData;
      this.chartElement.dataset.chartView = view;
      this._updateConfig();
      const targetToggle = this.toggles.find(toggle => toggle.dataset.chartView === view);
      this.toggles.forEach(toggle => toggle.classList.remove(this.activeClass));
      targetToggle.classList.add(this.activeClass);
    }

    _getChartConfig () {
      const chartView = this.chartElement.dataset.chartView;
      // set dataURL for chart
      const setPrint = (context) => {
        this.dataURL = context.chart.toBase64Image('image/png', 1);
      };
      switch (chartView) {
        case 'bar':
        return {
          type: 'bar',
          data: {
            labels: [null, null ,...this.data.props.map(item => item.prop), null, null],
            datasets: [{
              label: '',
              data: [null, null, ...this.data.props.map((dataItem) => {
                return dataItem[this.chartType].reduce((accum, number) => {
                  accum += number;
                  return accum;
                }, 0);
              }), null, null],
            }],
          },
          plugins: [
            {
              id: 'custom_canvas_background_color',
              beforeDraw: (chart) => {
                const ctx = chart.canvas.getContext('2d');
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, chart.width, chart.height);
                ctx.restore();
              },
            },
          ],
          options: {
            responsive: false,
            maintainAspectRatio: false,
            categoryPercentage: 0.9,
            borderRadius: 4,
            borderskipped: 'bottom',
            borderWidth: 0,
            backgroundColor: [null, null, ...this._getBgGradients(), null, null],
            animation: {
              onComplete: setPrint,
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                padding: 8,
                displayColors: true,
                titleFont: {
                  size: 14,
                  family: 'Roboto',
                },
                bodyFont: {
                  size: 14,
                  family: 'Roboto',
                },
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                  borderColor: 'rgba(225, 234, 245, 1)',
                },
                ticks: {
                  display: false,
                },
              },
              y: {
                grid: {
                  tickLength: 0,
                  borderDash: [8, 8],
                  borderWidth: 0,
                  color: 'rgba(225, 234, 245, 1)',
                },
                ticks: {
                  count: 4,
                  padding: 8,
                  font: {
                    size: 12,
                    family: 'Roboto',
                    color: 'rgba(59, 66, 86, 0.5)',
                  },
                  callback: function(value, index, values) {
                    return +Number.parseInt(value);
                  },
                },
              },
            },
          },
        };
        case 'line':
          // if (this.data.dates.length > 15) {
          //   this.chartElement.style.minWidth = `${this.data.dates.length * 45}px`;
          //   this.chartElement.parentNode.classList.add('custom-scroll');
          // } else {
          //   this.chartElement.style.minWidth = '100%';
          //   this.chartElement.parentNode.classList.remove('custom-scroll');
          // }
          return {
          type: 'line',
          data: {
            labels: this.data.dates,
            datasets: this.data.props.map((item, index) => {
              const dataset = {
                label: item.prop,
                data: item[this.chartType],
                borderColor: this._bgColors[index],
                pointHoverBackgroundColor: this._bgColors[index],
              };
              return dataset;
            }),
          },
          plugins: [
            {
              id: 'custom_canvas_background_color',
              beforeDraw: (chart) => {
                const ctx = chart.canvas.getContext('2d');
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, chart.width, chart.height);
                ctx.restore();
              },
            },
          ],
          options: {
            responsive: false,
            maintainAspectRatio: false,
            borderWidth: 1,
            cubicInterpolationMode: 'monotone',
            fill: false,
            pointRadius: 6,
            pointHitRadius: 20,
            pointBorderWidth: 0,
            pointBackgroundColor: 'rgba(255, 255, 255, 0)',
            pointHoverRadius: 4,
            animation: {
              onComplete: setPrint,
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                padding: 12,
                caretPadding: 5,
                displayColors: false,
                titleFont: {
                  size: 14,
                  family: 'Roboto',
                },
                bodyColor: 'rgba(255, 255, 255, 1)',
                bodyFont: {
                  size: 14,
                  family: 'Roboto',
                },
                bodySpacing: 0,
                callbacks: {
                  title: function (context) {
                    return context[0].formattedValue;
                  },
                  label: function (context) {
                    return context.dataset.label;
                  },
                }
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                  borderColor: 'rgba(225, 234, 245, 1)',
                },
                ticks: {
                  padding: 0,
                  font: {
                    size: 12,
                    family: 'Roboto',
                    color: 'rgba(59, 66, 86, 0.5)',
                  },
                },
              },
              y: {
                grid: {
                  tickLength: 0,
                  borderDash: [8, 8],
                  borderWidth: 0,
                  color: 'rgba(225, 234, 245, 1)',
                },
                ticks: {
                  count: 4,
                  padding: 8,
                  font: {
                    size: 12,
                    family: 'Roboto',
                    color: 'rgba(59, 66, 86, 0.5)',
                  },
                  callback: function(value, index, values) {
                    return +Number.parseInt(value);
                  },
                },
              },
            },
          },
        };
      };
    }

    _getBgGradients () {
      const barCtx = this.chartElement.getContext('2d');
      const gradients = this._GRAPH_COLORS.map(item => {
        const gradient = barCtx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, `rgba(${item.r}, ${item.g}, ${item.b}, 0.75)`);
        gradient.addColorStop(1, `rgba(${item.r}, ${item.g}, ${item.b}, 0.5)`);
        return gradient;
      });
      return gradients;
    }

    _updateConfig () {
      const newConfig = this._getChartConfig();
      this.chart.config.type = newConfig.type;
      this.chart.config.data = newConfig.data;
      this.chart.config.options = newConfig.options;
      this.chartElement.style.width ='100%';
      const width = this.chartElement.getBoundingClientRect().width;
      this.chart.resize(width, 250);
      this.chart.update();
    }

    _addListeners () {
      this.parent.addEventListener('click', this._toggleChart);
    }

    _toggleChart (evt) {
      if (!evt.target.matches(`.${this.toggleClass}`) || evt.target.matches(`.${this.toggleClass}.${this.activeClass}`)) return;
      evt.preventDefault();
      const toggle = evt.target;
      const chartView = toggle.dataset.chartView;
      this.chartElement.dataset.chartView = chartView;
      this._updateConfig();
      this.toggles.forEach(toggle => toggle.classList.remove(this.activeClass));
      toggle.classList.add(this.activeClass);
    }
  };

  const Param = class {
    constructor (parentElem) {
      this.parent = parentElem;
      this.params = [...this.parent.querySelectorAll(`.${PARAM_CLASS}`)];
      this.setParamClass = SET_PARAM_CLASS;
      this.selectClass = SELECT_CLASS;
      this.selectedClass = PARAM_SELECTED_CLASS;
      this.activeClass = 'active';
      this.initParam = this.params[0].dataset.param;
      this.handleClick = this.handleClick.bind(this);
      this.setInit();
      this.parent.addEventListener('input', this.handleClick);
    }

    show (param) {
      const selectedLists = [...this.parent.querySelectorAll(`.${this.selectedClass}[data-param=${param.dataset.param}]`)];
      selectedLists.forEach(list => list.classList.add(this.activeClass));
      param.classList.add(this.activeClass);
      const selectElements = param.querySelectorAll(`.${this.selectClass}`)
      selectElements.forEach(element => {
        choices[element.dataset.id].enable();
      });
    }

    hide (param) {
      const selectedLists = [...this.parent.querySelectorAll(`.${this.selectedClass}[data-param=${param.dataset.param}]`)];
      selectedLists.forEach(list => list.classList.remove(this.activeClass));
      param.classList.remove(this.activeClass);
      const selectElements = param.querySelectorAll(`.${this.selectClass}`);
      selectElements.forEach(element => {
        choices[element.dataset.id].disable();
      });
    }

    handleClick (evt) {
      if (!evt.target.matches(`.${this.setParamClass}`)) return;
      const paramType = evt.target.dataset.param;
      this.params.forEach(param => {
        const isMatch = param.dataset.param === paramType;
        isMatch ? this.show(param) : this.hide(param);
      });
    }

    setInit () {
      const paramType = this.initParam;
      this.params.forEach(param => {
        const isMatch = param.dataset.param === paramType;
        isMatch ? this.show(param) : this.hide(param);
      });
    }

    setChecked () {
      const checked = this.parent.querySelector(`.${this.setParamClass}:checked`);
      const paramType = checked.dataset.param;
      this.params.forEach(param => {
        const isMatch = param.dataset.param === paramType;
        isMatch ? this.show(param) : this.hide(param);
      });
    }
  };

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const MAP_WRAP_CLASS = 'js-stats-map-wrap';
  const MAP_PARENT_CLASS = 'js-stats-map-parent';
  const MAP_PRINT_CLASS = 'js-stats-map-print';
  const MAP_CLASS = 'js-stats-map';
  const MAP_GRID_CLASS = 'js-stats-map-grid';

  const MAP_DATA = {
    request: {
      'RU-ALT': 34,
      'RU-BEL': 45,
      'RU-STA': 294,
      'RU-KHA': 3,
      'RU-LIP': 100,
      'RU-PNZ': 188,
      'RU-TAM': 1000,
      'RU-KYA': 56,
      'RU-CHU': 744,
      'RU-KO': 700,
    },
    success: {
      'RU-ALT': 34,
      'RU-BEL': 5,
      'RU-STA': 294,
      'RU-KHA': 3,
      'RU-LIP': 3455,
      'RU-PNZ': 188,
      'RU-KYA': 2200,
      'RU-KO': 1500,
      'RU-CHU': 221,
      'RU-TAM': 233,
    },
    fail: {
      'RU-ALT': 2323,
      'RU-BEL': 45,
      'RU-STA': 43,
      'RU-KHA': 3,
      'RU-KYA': 1200,
      'RU-LIP': 23,
      'RU-KO': 1990,
      'RU-PNZ': 188,
      'RU-CHU': 244,
      'RU-TAM': 443,
    },
  };

  const Map = class {
    constructor (mapParent, ajaxData) {
      this.parent = mapParent;
      this.printButton = this.parent.querySelector(`.${MAP_PRINT_CLASS}`);
      this.mapElement = this.parent.querySelector(`.${MAP_CLASS}`);
      this.grid = this.mapElement.parentNode.querySelector(`.${MAP_GRID_CLASS}`);
      this.type = this.mapElement.dataset.chartType;
      this._options = {
        center: [66.868747, 100.365425],
        zoom: 2,
        controls: [],
      };
      this._defaultGeoOptions = {
        fillColor: '#ffffff',
        fillOpacity: 0,
        strokeStyle: 'solid',
        strokeColor: '#ffffff',
        strokeOpacity: 0.0000001,
      };
      this.init(ajaxData);
    }

    _getPointsCollection (data) {
      let pointsFeatures = [];
      for (const [regionId, regionData] of Object.entries(data)) {
        if (typeof regionData.points != 'undefined') {
          for (const [key, points] of Object.entries(regionData.points)) {
            let pointFeature = {
              type: "Feature",
              id: key,
              geometry: {
                type: "Point",
                coordinates: points.coords
              },
              properties: {
                balloonContent: points.name
              },
              options: {
                iconLayout: 'default#image',
                iconImageHref: '/local/templates/ibrush/svg_icons/map-icon-statistic.svg',
              }
            }
            pointsFeatures.push(pointFeature);
          }
        }
      }

      return {
        type: 'FeatureCollection',
        features: pointsFeatures
      };
    }

    init (ajaxData) {
      this.map = new ymaps.Map(this.mapElement, this._options);
      this.map.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
      const data = ajaxData[this.type];
      let dataNumbers = objectMap(data, function(obj) {
        return obj.count;
      });
      dataNumbers = Object.values(dataNumbers);
      if (!dataNumbers.length) return;

      let pointsCollection = this._getPointsCollection(data);

      ymaps.ready(() => {

        ymaps.borders.load('RU', {
          lang: 'ru',
          quality: 2,
          }).then(geojson => {
            this.collection = geojson.features.map(feature => {
              const region = feature.properties.iso3166;
              feature.id = region;

              if (typeof data[region] !== 'undefined' && data[region].count > 0) {
                const count = data[region].count;
                const percent = this._getPercent(count, dataNumbers)
                const color = this._getColor(percent);
                feature.options = {
                  fillColor: color,
                  fillOpacity: 0.4,
                  strokeColor: color,
                  strokeStyle: 'solid',
                  strokeOpacity: 0.5,
                };
              } else {
                feature.options = this._defaultGeoOptions;
              }
              return feature;
            });
            const objectCollection = {
              type: 'FeatureCollection',
              features: this.collection,
            };

            this.geoQuery = ymaps.geoQuery(objectCollection).addToMap(this.map);
            this.geoQueryPoints = ymaps.geoQuery(pointsCollection).addToMap(this.map);

            // const geoObject = this.geoQuery.searchContaining([55.771064, 37.661527]).get(0);
            // geoObject.options.set({
            //   fillColor: '#ff0000',
            //   fillOpacity: 1,
            // });
          })
          .catch(error => console.log(error));
        this._setGrid(dataNumbers);
      });
    }

    update (ajaxData) {

      this.map.destroy();
      this.init(ajaxData);
      return;

      const data = ajaxData[this.type];
      let dataNumbers = objectMap(data, function(obj) {
        return obj.count;
      });
      dataNumbers = Object.values(dataNumbers);
      this.geoQuery.each((geoObject) => {
        const region = geoObject.properties.get('iso3166');
        if (typeof data[region] !== 'undefined') {
          const count = data[region].count;
          const percent = this._getPercent(count, dataNumbers);
          const color = this._getColor(percent);
          geoObject.options.set({
            fillColor: color,
            fillOpacity: 0.4,
            strokeColor: color,
            strokeStyle: 'solid',
            strokeOpacity: 0.5,
          });
        } else {
          geoObject.options.set(this._defaultGeoOptions);
        }
      });

      this.geoQueryPoints.each((geoObject) => {
        this.geoQueryPoints.remove(geoObject);
      });

      let pointsCollection = this._getPointsCollection(data);
      //this.map.destroy();
    }

    _getPercent (nubmer, array) {
      let min = Math.min(...array)
      let max = Math.max(...array);
      if (min == max) return 1;
      const maxNormalized =  max - min;
      return (nubmer - Math.min(...array)) / maxNormalized;
    }

    _setGrid (numbers) {
      const NUMBER = 10;
      const min = Math.round(Math.min(...numbers));
      const step = Math.round((Math.max(...numbers) - Math.min(...numbers)) / NUMBER);
      let listItems = ``;
      const array = new Array(NUMBER).fill(null).map((item, index) => {
        item = min + (step * index);
        listItems += `
          <li class="stats__map-grid-item">${item}</li>
        `;
        return item;
      });
      this.grid.innerHTML = listItems;
    }

    _getColor (percent) {
      const MAX = 120;
      let h = MAX * percent,
          s = 95,
          l = 55;

      s /= 100;
      l /= 100;

      let c = (1 - Math.abs(2 * l - 1)) * s,
          x = c * (1 - Math.abs((h / 60) % 2 - 1)),
          m = l - c/2,
          r = 0,
          g = 0,
          b = 0;

      if (0 <= h && h < 60) {
        r = c; g = x; b = 0;
      } else if (60 <= h && h < 120) {
        r = x; g = c; b = 0;
      } else if (120 <= h && h < 180) {
        r = 0; g = c; b = x;
      } else if (180 <= h && h < 240) {
        r = 0; g = x; b = c;
      } else if (240 <= h && h < 300) {
        r = x; g = 0; b = c;
      } else if (300 <= h && h < 360) {
        r = c; g = 0; b = x;
      }
      r = Math.round((r + m) * 255).toString(16);
      g = Math.round((g + m) * 255).toString(16);
      b = Math.round((b + m) * 255).toString(16);
      if (r.length == 1)
        r = "0" + r;
      if (g.length == 1)
        g = "0" + g;
      if (b.length == 1)
        b = "0" + b;
      return "#" + r + g + b;
    }
  }

  const AnalyticsPage = class {
    constructor (page) {
      this.parent = page;
      this.form = this.parent.querySelector(`.${FORM_CLASS}`);
      this.chartView = this.form.querySelector(`.${CHART_VIEW_CLASS}`);
      this.chartViewInputClass = CHART_VIEW_INPUT_CLASS;
      this.chartViewInputs = [...this.chartView.querySelectorAll(`.${this.chartViewInputClass}`)];
      this.paramElement = this.form.querySelector(`.${PARAM_PARENT_CLASS}`);
      this.param = new Param(this.paramElement);
      this.chartWrap = this.parent.querySelector(`.${CHART_WRAP_CLASS}`);
      this.chartArea = this.parent.querySelector(`.${CHART_AREA_CLASS}`);
      this.chartInterval = {
        start: this.parent.querySelector(`.${CHART_INTERVAL_START_CLASS}`),
        end: this.parent.querySelector(`.${CHART_INTERVAL_END_CLASS}`),
      };
      this.chartName = this.parent.querySelector(`.${CHART_NAME_CLASS}`);
      this.chartProps = this.parent.querySelector(`.${CHART_PROPS_CLASS}`);
      this.chartElements = [...this.parent.querySelectorAll(`.${CHART_PARENT_CLASS}`)];
      this.chartPrintText = this.parent.querySelector(`.${CHART_PRINT_TEXT_CLASS}`);
      this.charts = [];
      this.initClass = 'init';
      this.activeClass = 'active';
      this.mapWrap = this.parent.querySelector(`.${MAP_WRAP_CLASS}`);
      this.mapParents = [...this.mapWrap.querySelectorAll(`.${MAP_PARENT_CLASS}`)];
      this.maps = [];
      this.adaptElements = [...this.form.querySelectorAll(`.${ADAPT_CLASS}`)];
      this._adaptForm = this._adaptForm.bind(this);
      this._printChart = this._printChart.bind(this);
      this._addListeners();
    }

    _addListeners () {
      this.form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        if (!validateForm(evt.target)) {
          return;
        };
        // this.chartView.disabled = true;
        const data = new FormData(evt.target);
        // this.chartView.disabled = false;
        ajaxTemplate(data)
          .then(data => this._update(data))
          .catch(error => {
            console.log(error);
            popupError.open();
          });
      });
      this.form.addEventListener('reset', (evt) => {
        resetSelect(evt);
        this.param.setInit();
        this.adaptElements.forEach(element => this._showAdapt(element));
        this.chartWrap.classList.remove(this.activeClass);
        this.mapWrap.classList.remove(this.activeClass);
        // let data = new FormData(evt.target);
        // setTimeout(() => {
        //   ajaxTemplate()
        //     .then(data => this._update(data))
        //     .catch(error => {
        //       console.log(error);
        //       popupError.open();
        //     });
        // }, 0);
      });
      this.chartView.addEventListener('change', this._adaptForm);
    }

    _adaptForm (evt) {
      if (!evt.target.matches(`.${this.chartViewInputClass}`)) return;
      const view = evt.target.dataset.view;
      if (view === 'map') {
        this.adaptElements.forEach(element => this._hideAdapt(element));
      } else {
        this.adaptElements.forEach(element => this._showAdapt(element));
        this.param.setChecked();
      }
    }

    _hideAdapt (element) {
      element.classList.remove(this.activeClass);
      [...element.querySelectorAll('input')].forEach(input => input.disabled = true);
    }

    _showAdapt (element) {
      element.classList.add(this.activeClass);
      [...element.querySelectorAll('input')].forEach(input => input.disabled = false);
    }

    _setText (data) {
      this.chartArea.textContent = data.area;
      this.chartInterval.start.textContent = data.interval.start;
      this.chartInterval.end.textContent = data.interval.end;
      this.chartName.textContent = data.name;
      // const colors = ['#508AFF', '#F3A83E', '#31D99C', '#E54D60', '#8567FF', '#EC79FF'];
      const props = data.props.reduce((accum, item, index) => {
        accum +=
          `<li class="stats__an-param-item">
            <span class="stats__an-param-dot"></span>
            <p class="stats__an-param-text">${item.prop}</p>
          </li>`;
        return accum;
      }, '');
      this.chartProps.innerHTML = props;
    }

    _update (data) {
      const activeViewToggle = this.chartViewInputs.find(input => input.checked);
      const view = activeViewToggle.dataset.view;
      if (view === 'map') {
        if (this.mapWrap.classList.contains(this.initClass)) {
          this._initMap(data.props);
          return;
        }
        this.chartWrap.classList.remove(this.activeClass);
        this.mapWrap.classList.add(this.activeClass);
        requestAnimationFrame(() => {
          this.maps.forEach(map => {
            map.update(data.props);
          });
        });
      } else {
        if (this.chartWrap.classList.contains(this.initClass)) {
          this._initChart(data, view);
          return;
        }
        this.mapWrap.classList.remove(this.activeClass);
        this.chartWrap.classList.add(this.activeClass);
        requestAnimationFrame(() => {
          this._setText(data);
          this.charts.forEach(chart => {
            chart.updateView(data, view);
          });
        });
      }
    }

    _initChart (data, view) {
      this.chartWrap.classList.remove(this.initClass);
      this.mapWrap.classList.remove(this.activeClass);
      this.chartWrap.classList.add(this.activeClass);
      requestAnimationFrame(() => {
        this._setText(data);
        this.chartElements.forEach(element => {
          const chart = new MyChart(element, data);
          this.charts.push(chart);
          chart.updateView(data, view);
          chart.printButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._printChart(chart);
          });
        });
      });
    }

    _initMap (data) {
      this.mapWrap.classList.remove(this.initClass);
      this.chartWrap.classList.remove(this.activeClass);
      this.mapWrap.classList.add(this.activeClass);
      requestAnimationFrame(() => {
        this.mapParents.forEach(mapParent => {
          const map = new Map(mapParent, data);
          this.maps.push(map);
          map.printButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._printMap(map);
          });
        });
      });
    }

    _printChart (chart) {
      const myWindow = window.open('', 'Печать графика', 'height=400,width=600');
      myWindow.document.open();
      const styles = `
        .stats__an-top-wrap {
          display: grid;
          grid-auto-flow: column;
          justify-content: start;
          align-items: start;
          grid-gap: 2.4rem;
          margin-bottom: 1.6rem;
          font-size: 1.4rem;
          line-height: 1.14;
          color: #b8bcc6;
        }

        .stats__an-top-wrap p {
          margin: 0;
        }

        .stats__an-city {
          margin: 0;
        }

        .stats__an-title {
          margin-top: 0;
          font-family: "Roboto", "Arial", sans-serif;
          margin-bottom: 1rem;
        }

        .stats__an-param-list {
          margin: 0;
          margin-bottom: 1rem;
          padding: 0;
          list-style: none;

        }

        .stats__an-param-list li {
          margin: 0;
          padding: 0;
        }

        .stats__an-param-list li:not(:last-of-type),
        .stats__an-param-list li:not(:last-of-type) {
          margin-bottom: 0.6rem;
        }

        .stats__an-param-list li::before {
          display: none;
        }

        .stats__an-param-item {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-gap: 1.1rem;
          align-items: center;
          justify-content: start;
          font-family: "Roboto", "Arial", sans-serif;
        }
        .stats__an-param-item:last-child {
          margin-bottom: 0;
        }

        .stats__an-param-item:nth-child(1) .stats__an-param-dot {
          background-color: #508AFF;
        }
        .stats__an-param-item:nth-child(2) .stats__an-param-dot {
          background-color: #F3A83E;
        }
        .stats__an-param-item:nth-child(3) .stats__an-param-dot {
          background-color: #31D99C;
        }
        .stats__an-param-item:nth-child(4) .stats__an-param-dot {
          background-color: #E54D60;
        }
        .stats__an-param-item:nth-child(5) .stats__an-param-dot {
          background-color: #8567FF;
        }
        .stats__an-param-item:nth-child(6) .stats__an-param-dot {
          background-color: #EC79FF;
        }

        .stats__an-param-dot {
          display: block;
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background-color: #c0c3c9;
        }

        .stats__an-param-text {
          margin: 0;
          font-size: 1rem;
          line-height: 1.14;
          font-weight: 500;
        }

        .stats__print-title {
          margin: 0;
          font-family: "Roboto", "Arial", sans-serif;
          font-size: 1.2rem;
          line-height: 1.2;
          font-weight: 700;
        }
      `;
      let windowContent = '<!DOCTYPE html><html><head><title>' + document.title  + '</title>';
      windowContent += `<style>${styles}</style></head><body>`;
      windowContent += this.chartPrintText.innerHTML;
      windowContent += `<h1 class="stats__print-title">${chart.title.textContent}<h1>`;
      const image = `<img src="${chart.dataURL}" width="600" height="250">`;
      windowContent += image;
      windowContent += '</body></html>';
      myWindow.document.write(windowContent);
      myWindow.focus();
      setTimeout(() => {
        myWindow.print();
        myWindow.document.close();
        myWindow.close();
      }, 0)
      return true;
    }

    _printMap (map) {
      const PRINT_MAP_CLASS = 'print-map';
      document.body.classList.add(PRINT_MAP_CLASS);
      map.parent.classList.add(PRINT_MAP_CLASS);
      window.print();
      document.body.classList.remove(PRINT_MAP_CLASS);
      map.parent.classList.remove(PRINT_MAP_CLASS);
    }
  }

  const analyticsPageElement = document.querySelector(`.${ANALYTICS_PAGE_CLASS}`);
  const analyticsPage = new AnalyticsPage(analyticsPageElement);

  $(document).on('click', '.js-kos-stats-map', function (e) {
    e.preventDefault();

    let formData = new FormData($('.js-stats-analytics .js-stats-form')[0]);
    formData.delete('action');
    formData.delete('AREA[]');
    formData.append('action', 'getKosAnalytics');
    formData.append('AREA', $(this).data('area-id'));
    //formData.append('id', skill);

    const sumArray = (array) => array.reduce((accum, item) => {
      accum += item;
      return accum;
    }, null);

    let areaName = $(this).data('area-name');


    ajaxTemplate(formData).then(data => {

      const tableRows = data.props.reduce((accum, item) => {
        accum +=
          `<tr class="stats__skill-tr">
            <td class="stats__skill-td">${item.prop}</td>
            <td class="stats__skill-td">${sumArray(item.request)}</td>
            <td class="stats__skill-td">${sumArray(item.success)}</td>
            <td class="stats__skill-td">${sumArray(item.fail)}</td>
          </tr>`
        return accum;
      }, '');
      $('[data-popup=map-stats-table] .js-stats-popup-name').text(areaName);
      $('[data-popup=map-stats-table] .js-stats-popup-table').html(tableRows);


      let popup = new Popup(document.querySelector(`[data-popup=map-stats-table]`));
      popup.open();
    }).catch(error => {
      console.log(error);
    });
  })


  $(document).on('click', '.js-kos-stats-export', function (e) {
    e.preventDefault();

    let formData = new FormData($('.js-stats-table .js-stats-form')[0]);
    formData.delete('action');
    formData.append('action', 'getKosAnalyticsExport');

    BX.showWait();

    ajaxTemplate(formData).then(data => {
      BX.closeWait();
      window.open(data.file, '_blank').focus();
    }).catch(error => {
      BX.closeWait();
      console.log(error);
    });
  })
}

$('.js-modal-link[data-target=export-statistics]').on('click', function(e){
  if ($(this).attr('href')) {
    e.preventDefault();
  }
  var target = $('[data-modal='+ $(this).data('target') +']');
  modal(target);
});

$(document).on('click', '.js-export-statistics', function () {
  BX.showWait();

  let query = {
    c: 'ibrush:statistics.mcok',
    action: 'export',
    mode: 'class'
  };

  let data = {
    type: $(this).data('type'),
    dateFrom: $('input[name=DATE_FROM]').val(),
    dateTo: $('input[name=DATE_TO]').val(),
    place: $('select[name=AREA]').val(),
    pk: $('select[name="SKILL[]"]').val(),
    SITE_ID: 's1',
    sessid: BX.message('bitrix_sessid')
  };

  let request = $.ajax({
    url: '/bitrix/services/main/ajax.php?' + $.param(query, true),
    method: 'GET',
    data: data
  });

  return new Promise((resolve, reject) => {
    request.done(function (response) {
      BX.closeWait();
      if (response.status != 'success' || !response.data.file) {
        reject('Произошла ошибка, попробуйте позже');
      } else {
        window.location.href = response.data.file;
      }
    });
  });
});



$(document).ready(function() {
  $('.js-employer-user-select').on('change', function () {
    if ($(this).val()) {
      window.location.href = '/personal/exams/?user_id=' + $(this).val();
    }
  });
});

$(document).on('click', '._js-clear-notifications', function () {
  let notificationType = $(this).data('notification-type');
  let notificationEntity = $(this).data('notification-entity');
  $(this).siblings('.notification-wrapper').hide();
  clearNotifications(notificationType, notificationEntity);
  if ($(this).hasClass('_js-clear-all-exam-notify')) {
    $(".aside-navigation__link[href='/personal/exams/']").siblings('.aside-navigation__notifications').hide();
  }
});

$(document).ready(function() {
  let $firstTabLink = $('.tabs-list__link').first();
  if ($firstTabLink.hasClass('_js-clear-notifications')) {
    let notificationType = $firstTabLink.data('notification-type');
    let notificationEntity = $firstTabLink.data('notification-entity');
    clearNotifications(notificationType, notificationEntity);
  }
});

function clearNotifications(type, entity) {
  let data = {type: type};
  if (typeof entity !== 'undefined') {
    data.entity = entity;
  }
  BX.ajax({
    url: '/local/ajax/removeNotifications.php',
    method: 'POST',
    data: data,
    dataType: 'json',
    onsuccess: function(result) {
      if (result.error) {

      } else {

      }
    }
  });
}

$(document).ready(function () {
  if (document.querySelector(".styled-list__list")) {
    const styledLists = document.querySelectorAll(".styled-list__list");

    styledLists.forEach((list) => {
      const styledListItems = list.querySelectorAll(".styled-list__element");

      function hideElements() {
        styledListItems.forEach((item, index) => {
          if (index > 7) {
            item.classList.add("hide");
          }
        });
      }

      if (styledListItems.length > 8) {
        const itemHeight = styledListItems[0].offsetHeight;
        const listContainer = document.querySelector('.styled-list');
        const listContainerOffset = listContainer.offsetTop;
        const timeDelay = 5;

        hideElements();

        let active = false;

        const showButton = document.createElement("button");
        showButton.className = "styled-list__element styled-list__button";
        showButton.textContent = "Показать все квалификации";
        list.append(showButton);

        list.style.height = `${8 * itemHeight + showButton.offsetHeight + 6}px`;

        showButton.addEventListener("click", () => {
          if (active) {
            let waitTime = styledListItems.length * timeDelay;
            window.scrollTo({
              top: listContainerOffset,
              behavior: 'smooth',
            });

            setTimeout(function () {
              list.style.height = `${8 * itemHeight + showButton.offsetHeight + 6}px`;
            }, waitTime);

            list.style.overflow = 'hidden';
            listContainer.style.removeProperty('margin-bottom');
            showButton.style.bottom = '0';

            active = false;
						showButton.textContent = "Показать все квалификации";
            setTimeout(() => {
              hideElements();
            }, waitTime);
          } else {
            styledListItems.forEach((item) => {
              item.classList.remove("hide");
            });

            list.style.removeProperty('height');
            list.style.overflow = 'initial';
            listContainer.style.marginBottom = '80px';
            showButton.style.bottom = '-40px';

            active = true;
						showButton.textContent = "Свернуть все квалификации";
          }
        });
      }
    });
  }
});

function initCookiePopup() {
  const $popup = $('.js-cookie-popup');
  const delay = 3 * 1000;
  const cookieKey = 'acceptCookiePolicy';
  if(hasCookie() || !$popup.length) return


  setTimeout(() => {
      $popup.addClass('_active')
  }, delay);

  $popup.find('.js-accept-cookie').on('click', function() {
      addCookie()
      $popup.removeClass('_active');
  });

  function addCookie() {
      document.cookie = `${cookieKey}=true; path=/; expires=Fri, 25 Jun 2038 05:24:33 GMT`
  }

  function hasCookie() {
      const value = document.cookie.split('; ').find((i) => i.startsWith(cookieKey))
      return value === `${cookieKey}=true`
  }
}



